import { useState, useRef, useEffect, useCallback } from "react";
import AdminPanel from "./pages/AdminPanel";

/* ─── STYLES ──────────────────────────────────────────────────────────────── */
const G = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    :root{
      --teal:#0d9488;--teal-d:#0f766e;--teal-l:#f0fdfa;--teal-m:#ccfbf1;
      --amber:#f59e0b;--amber-l:#fffbeb;
      --red:#ef4444;--red-l:#fef2f2;
      --green:#10b981;--green-l:#ecfdf5;
      --blue:#3b82f6;--blue-l:#eff6ff;
      --gray-50:#f9fafb;--gray-100:#f3f4f6;--gray-200:#e5e7eb;
      --gray-300:#d1d5db;--gray-400:#9ca3af;--gray-500:#6b7280;
      --gray-600:#4b5563;--gray-700:#374151;--gray-800:#1f2937;--gray-900:#111827;
      --font:'Plus Jakarta Sans',system-ui,sans-serif;
      --sh:0 1px 3px rgba(0,0,0,.07);--sh2:0 4px 12px rgba(0,0,0,.08);--sh3:0 12px 32px rgba(0,0,0,.12);
      --r:14px;--r2:10px;--r3:8px;
    }
    body{font-family:var(--font);background:var(--gray-50);color:var(--gray-900);-webkit-font-smoothing:antialiased}
    input,button,select,textarea{font-family:var(--font)}
    input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}
    ::-webkit-scrollbar{width:4px;height:4px}
    ::-webkit-scrollbar-thumb{background:var(--gray-200);border-radius:4px}
    @keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
    @keyframes popIn{from{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}
    @keyframes slideDown{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}
    @keyframes scanLine{0%{top:8%}50%{top:82%}100%{top:8%}}
    .fu{animation:fadeUp .3s ease both}
    .fu1{animation:fadeUp .3s .06s ease both}
    .fu2{animation:fadeUp .3s .12s ease both}
    .fu3{animation:fadeUp .3s .18s ease both}
    .fu4{animation:fadeUp .3s .24s ease both}
    .fu5{animation:fadeUp .3s .30s ease both}

    /* ── Responsive grid helpers ── */
    .grid2{display:grid;grid-template-columns:1fr 1fr;gap:18px}
    .grid4{display:grid;grid-template-columns:repeat(4,1fr);gap:10px}
    .grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}
    @media(max-width:640px){
      .grid2{grid-template-columns:1fr;gap:12px}
      .grid4{grid-template-columns:1fr 1fr;gap:8px}
      .grid3{grid-template-columns:1fr 1fr;gap:8px}
      .hide-mobile{display:none!important}
      .full-mobile{width:100%!important}
    }
  `}</style>
);

/* ─── API LAYER ───────────────────────────────────────────────────────────── */
const BASE = "/api";

async function apiFetch(path, options = {}) {
  const token = localStorage.getItem("hs_token");
  const res = await fetch(BASE + path, {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: "Bearer " + token } : {}),
    },
    ...options,
  });
  if (res.status === 401) {
    localStorage.removeItem("hs_token");
    localStorage.removeItem("hs_shop");
    window.location.reload();
    return;
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || "Kosa la seva");
  }
  if (res.status === 204) return null;
  return res.json();
}

const api = {
  login:    (email, pw)  => apiFetch("/auth/ingia",  { method: "POST", body: JSON.stringify({ email, password: pw }) }),
  register: (body)       => apiFetch("/auth/sajili", { method: "POST", body: JSON.stringify(body) }),
  products: {
    list:        (q="")  => apiFetch("/bidhaa" + (q ? "?q=" + q : "")),
    create:      (b)     => apiFetch("/bidhaa",        { method: "POST",   body: JSON.stringify(b) }),
    updateStock: (id, s) => apiFetch("/bidhaa/" + id + "/stoki", { method: "PATCH", body: JSON.stringify({ idadi: s }) }),
    remove:      (id)    => apiFetch("/bidhaa/" + id,  { method: "DELETE" }),
    categories: {
      list:   ()     => apiFetch("/bidhaa/categories"),
      create: (name) => apiFetch("/bidhaa/categories", { method: "POST", body: JSON.stringify({ name }) }),
      remove: (id)   => apiFetch("/bidhaa/categories/" + id, { method: "DELETE" }),
    },
  },
  sales: {
    list:   (day)  => apiFetch("/mauzo" + (day ? "?siku=" + day : "")),
    create: (b)    => apiFetch("/mauzo",  { method: "POST", body: JSON.stringify(b) }),
  },
  debts: {
    list:   ()     => apiFetch("/madeni"),
    create: (b)    => apiFetch("/madeni",          { method: "POST",   body: JSON.stringify(b) }),
    pay:    (id)   => apiFetch("/madeni/" + id + "/lipa", { method: "PATCH" }),
    remove: (id)   => apiFetch("/madeni/" + id,    { method: "DELETE" }),
  },
  expenses: {
    list:   ()     => apiFetch("/gharama"),
    create: (b)    => apiFetch("/gharama", { method: "POST",   body: JSON.stringify(b) }),
    remove: (id)   => apiFetch("/gharama/" + id, { method: "DELETE" }),
  },
  dashboard: ()    => apiFetch("/ripoti/dashibodi"),
  njiamalipo: ()   => apiFetch("/ripoti/njia-malipo"),
  orders: {
    list:    (hali)  => apiFetch("/orders" + (hali ? "?hali="+hali : "")),
    create:  (b)     => apiFetch("/orders", { method: "POST", body: JSON.stringify(b) }),
    fulfill: (id, p) => apiFetch("/orders/"+id+"/timiza", { method: "POST", body: JSON.stringify({ njia_malipo: p }) }),
    cancel:  (id)    => apiFetch("/orders/"+id+"/futa", { method: "PATCH" }),
  },
  users: {
    list:   ()         => apiFetch("/users"),
    create: (b)        => apiFetch("/users", { method: "POST", body: JSON.stringify(b) }),
    toggle: (id)       => apiFetch("/users/"+id+"/hali", { method: "PATCH" }),
    remove: (id)       => apiFetch("/users/"+id, { method: "DELETE" }),
    staffLogin: (s, p) => apiFetch("/users/ingia", { method: "POST", body: JSON.stringify({ simu: s, password: p }) }),
  },
};

/* ─── HELPERS ─────────────────────────────────────────────────────────────── */
const fmt   = n => "TZS " + Number(n||0).toLocaleString("en-TZ");
const fmtN  = n => Number(n||0).toLocaleString("en-TZ");
const dateStr = () => new Date().toLocaleDateString("sw-TZ",{day:"2-digit",month:"long",year:"numeric"});
const timeStr = () => new Date().toLocaleTimeString("en-TZ",{hour:"2-digit",minute:"2-digit"});
const todayStr= () => new Date().toLocaleDateString("sw-TZ",{weekday:"long",day:"numeric",month:"long",year:"numeric"});
const PAY_COLORS = {Cash:"var(--green)","M-Pesa":"var(--teal)",Airtel:"var(--red)",Tigo:"var(--blue)",Mkopo:"var(--amber)"};

/* ─── SAMPLE FALLBACK DATA (shown when API returns empty) ────────────────── */
const SAMPLE_PRODS = [
  {id:"s1",barcode:"6001234500001",name:"Unga wa Ngano 2kg",sku:"UNG-2KG",price:4500,cost:3800,stock:42,unit:"mfuko",cat:"Vyakula"},
  {id:"s2",barcode:"6001234500002",name:"Unga wa Ngano 5kg",sku:"UNG-5KG",price:10500,cost:8900,stock:18,unit:"mfuko",cat:"Vyakula"},
  {id:"s3",barcode:"6001234500003",name:"Mchele 1kg",sku:"MCH-1KG",price:3200,cost:2600,stock:0,unit:"kg",cat:"Vyakula"},
  {id:"s4",barcode:"6001234500004",name:"Mchele 5kg",sku:"MCH-5KG",price:15500,cost:13000,stock:7,unit:"mfuko",cat:"Vyakula"},
  {id:"s5",barcode:"6001234500005",name:"Sukari 1kg",sku:"SUK-1KG",price:2800,cost:2200,stock:55,unit:"kg",cat:"Vyakula"},
  {id:"s6",barcode:"6001234500006",name:"Mafuta 1L",sku:"MAF-1L",price:6200,cost:5100,stock:30,unit:"chupa",cat:"Vyakula"},
  {id:"s7",barcode:"6001234500007",name:"Sabuni 500g",sku:"SAB-500G",price:1800,cost:1400,stock:88,unit:"pakiti",cat:"Usafi"},
  {id:"s8",barcode:"6001234500008",name:"Chumvi 500g",sku:"CHU-500G",price:600,cost:400,stock:120,unit:"pakiti",cat:"Vyakula"},
  {id:"s9",barcode:"6001234500009",name:"Chai 100g",sku:"CHA-100G",price:2200,cost:1700,stock:3,unit:"pakiti",cat:"Vinywaji"},
];
const SAMPLE_DASHBOARD = {
  today_sales:189000,month_sales:1746000,month_expenses:318000,net_profit:66120,
  out_of_stock:2,unpaid_debts:63700,
  low_stock:[{name:"Mchele 5kg",stock:7},{name:"Chai 100g",stock:3}],
  sales_chart:[
    {date:"2026-03-19",total:187000},{date:"2026-03-20",total:243000},{date:"2026-03-21",total:198000},
    {date:"2026-03-22",total:312000},{date:"2026-03-23",total:276000},{date:"2026-03-24",total:341000},{date:"2026-03-25",total:189000},
  ],
  recent_sales:[
    {id:"r1",maelezo:"Unga 2kg x3 + Sukari 1kg x2",kiasi:19100,njia_malipo:"cash",created_at:new Date().toISOString(),customer:"Mama Fatuma"},
    {id:"r2",maelezo:"Mafuta 1L x2 + Chai 100g x1",kiasi:14600,njia_malipo:"mpesa",created_at:new Date().toISOString()},
    {id:"r3",maelezo:"Mchele 5kg x1",kiasi:15500,njia_malipo:"mkopo",created_at:new Date().toISOString(),customer:"Bw. Hassan"},
  ],
};

function formatReceipt(items, total, customer, size="80") {
  const W=size==="58"?32:48, L=size==="58"?"─":"═";
  const line=L.repeat(W);
  const c=s=>" ".repeat(Math.max(0,Math.floor((W-s.length)/2)))+s;
  const cols=(l,r)=>l+" ".repeat(Math.max(1,W-l.length-r.length))+r;
  let r=c("HESABUSMART ERP")+"\n"+c("hesabusmart.co.tz")+"\n"+line+"\n";
  r+=cols("Tarehe:",dateStr())+"\n"+cols("Saa:",timeStr())+"\n";
  if(customer) r+=cols("Mteja:",customer)+"\n";
  r+=line+"\n";
  items.forEach(i=>{
    const n=i.name.length>18?i.name.slice(0,17)+"…":i.name;
    r+=n+"\n"+cols("  "+i.qty+" x "+fmtN(i.price),fmtN(i.qty*i.price))+"\n";
  });
  r+=line+"\n"+cols("JUMLA:",fmtN(total))+"\n"+line+"\n"+c("Asante! Karibu tena")+"\n";
  return r;
}

/* ─── UI ATOMS ───────────────────────────────────────────────────────────── */
function Toast({message,type,onDone}){
  useEffect(()=>{const t=setTimeout(onDone,2800);return()=>clearTimeout(t)},[onDone]);
  const bc={success:"var(--green)",error:"var(--red)",warn:"var(--amber)",info:"var(--teal)"}[type]||"var(--teal)";
  return <div style={{position:"fixed",bottom:76,left:"50%",transform:"translateX(-50%)",zIndex:9999,
    background:"white",border:"2px solid "+bc,borderRadius:12,padding:"11px 20px",
    color:"var(--gray-900)",fontSize:13,fontWeight:700,boxShadow:"var(--sh3)",
    animation:"fadeUp .3s ease",whiteSpace:"nowrap",maxWidth:"90vw"}}>{message}</div>;
}

function Modal({title,children,onClose,width=480}){
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:1000,
    display:"flex",alignItems:"flex-end",justifyContent:"center",
    backdropFilter:"blur(3px)",padding:"0"}}
    onClick={onClose}>
    <div style={{background:"white",borderRadius:"20px 20px 0 0",padding:24,
      width:"100%",maxWidth:width,maxHeight:"92vh",overflowY:"auto",
      boxShadow:"var(--sh3)",animation:"fadeUp .25s ease"}}
      onClick={e=>e.stopPropagation()}>
      <div style={{width:40,height:4,background:"var(--gray-200)",borderRadius:2,margin:"0 auto 20px"}}/>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div style={{fontSize:15,fontWeight:800}}>{title}</div>
        <button onClick={onClose} style={{background:"var(--gray-100)",border:"none",width:30,height:30,
          borderRadius:"var(--r3)",cursor:"pointer",fontSize:17,color:"var(--gray-500)",
          display:"flex",alignItems:"center",justifyContent:"center"}}>x</button>
      </div>
      {children}
    </div>
  </div>;
}

function Inp({label,value,onChange,placeholder,type="text",required}){
  const [f,setF]=useState(false);
  return <div style={{marginBottom:14}}>
    {label&&<label style={{fontSize:11,fontWeight:700,color:"var(--gray-500)",display:"block",
      marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>{label}{required?" *":""}</label>}
    <input type={type} value={value} onChange={onChange} placeholder={placeholder}
      onFocus={()=>setF(true)} onBlur={()=>setF(false)}
      style={{width:"100%",padding:"12px 14px",
        border:"2px solid "+(f?"var(--teal)":"var(--gray-200)"),
        borderRadius:"var(--r2)",fontSize:14,outline:"none",background:"white",
        color:"var(--gray-900)",transition:"border-color .2s"}}/>
  </div>;
}

function Btn({children,onClick,v="primary",sz="md",disabled,full,style={}}){
  const vs={
    primary:{background:"var(--teal)",color:"white",boxShadow:"0 3px 10px rgba(13,148,136,.25)"},
    secondary:{background:"var(--gray-100)",color:"var(--gray-700)",boxShadow:"none"},
    danger:{background:"var(--red-l)",color:"var(--red)",boxShadow:"none"},
    success:{background:"var(--green-l)",color:"var(--green)",boxShadow:"none"},
    outline:{background:"white",color:"var(--teal)",border:"2px solid var(--teal)",boxShadow:"none"},
    wa:{background:"#25D366",color:"white",boxShadow:"0 3px 10px rgba(37,211,102,.25)"},
  };
  const ss={
    sm:{padding:"7px 14px",fontSize:12,borderRadius:"var(--r3)"},
    md:{padding:"11px 18px",fontSize:13,borderRadius:"var(--r2)"},
    lg:{padding:"14px 22px",fontSize:15,borderRadius:"var(--r)"},
  };
  return <button onClick={disabled?undefined:onClick} disabled={disabled}
    style={{fontFamily:"var(--font)",fontWeight:700,cursor:disabled?"not-allowed":"pointer",
      border:"none",display:"inline-flex",alignItems:"center",justifyContent:"center",gap:6,
      transition:"all .18s",opacity:disabled?.55:1,width:full?"100%":"auto",
      ...vs[v],...ss[sz],...style}}>{children}</button>;
}

function Card({children,className="",style={}}){
  return <div className={className} style={{background:"white",borderRadius:"var(--r)",
    boxShadow:"var(--sh)",border:"1px solid var(--gray-100)",padding:16,...style}}>{children}</div>;
}

function STitle({children}){
  return <div style={{fontSize:10,fontWeight:800,color:"var(--teal)",textTransform:"uppercase",
    letterSpacing:1.2,marginBottom:12}}>{children}</div>;
}

function Badge({children,color="teal"}){
  const map={teal:["var(--teal-m)","var(--teal-d)"],green:["var(--green-l)","var(--green)"],
    red:["var(--red-l)","var(--red)"],amber:["var(--amber-l)","var(--amber)"],
    blue:["var(--blue-l)","var(--blue)"],gray:["var(--gray-100)","var(--gray-500)"]};
  const [bg,cl]=map[color]||map.teal;
  return <span style={{fontSize:10,padding:"3px 9px",borderRadius:20,fontWeight:700,
    background:bg,color:cl,whiteSpace:"nowrap"}}>{children}</span>;
}

function Spinner(){
  return <div style={{display:"flex",alignItems:"center",justifyContent:"center",padding:40}}>
    <div style={{width:28,height:28,border:"3px solid var(--teal-m)",
      borderTopColor:"var(--teal)",borderRadius:"50%",animation:"spin .7s linear infinite"}}/>
    <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
  </div>;
}

/* ─── AUTH SCREENS ───────────────────────────────────────────────────────── */
function AuthScreen({onLogin}){
  const [view,setView]=useState("login"); // login | staff | register
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState("");
  const [loginForm,setLoginForm]=useState({email:"",password:""});
  const [loginMethod,setLoginMethod]=useState("phone"); // phone | email
  const [staffForm,setStaffForm]=useState({simu:"",password:""});
  const [regForm,setRegForm]=useState({jina_duka:"",jina_mmiliki:"",email:"",password:"",simu:"",mahali:""});
  const [regMethod,setRegMethod]=useState("phone"); // phone | email

  async function doLogin(){
    if(!loginForm.email||!loginForm.password){setError("Jaza namba ya simu/email na nywila");return;}
    setLoading(true);setError("");
    try{
      const res=await api.login(loginForm.email,loginForm.password);
      if(!res||!res.token) throw new Error("Jibu batili");
      const shopData={...res.shop};
      localStorage.setItem("hs_token",res.token);
      localStorage.setItem("hs_shop",JSON.stringify(shopData));
      localStorage.removeItem("hs_user");
      setRegForm({jina_duka:"",jina_mmiliki:"",email:"",password:"",simu:"",mahali:""});
      onLogin(shopData);
    }catch(e){setError(e.message||"Hitilafu ya seva");}
    setLoading(false);
  }

  async function doStaffLogin(){
    if(!staffForm.simu||!staffForm.password){setError("Jaza nambari ya simu na nywila");return;}
    setLoading(true);setError("");
    try{
      const res=await api.users.staffLogin(staffForm.simu,staffForm.password);
      localStorage.setItem("hs_token",res.token);
      localStorage.setItem("hs_shop",JSON.stringify({...res.user,name:res.user.shop_name}));
      localStorage.setItem("hs_user",JSON.stringify(res.user));
      onLogin({...res.user,name:res.user.shop_name});
    }catch(e){setError(e.message);}
    setLoading(false);
  }

  async function doRegister(){
    if(!regForm.jina_duka||!regForm.jina_mmiliki||!regForm.password){setError("Jaza sehemu zote *");return;}
    if(!regForm.email&&!regForm.simu){setError("Weka barua pepe au namba ya simu");return;}
    if(regForm.password.length<6){setError("Nywila iwe na herufi 6+");return;}
    setLoading(true);setError("");
    try{
      const res=await api.register(regForm);
      if(res&&res.pending){
        setRegForm({jina_duka:"",jina_mmiliki:"",email:"",password:"",simu:"",mahali:""});
        setError("");
        setLoading(false);
        setView("login");
        alert(res.message);
        return;
      }
      if(!res||!res.token) throw new Error("Jibu batili");
      const shopData={...res.shop};
      localStorage.setItem("hs_token",res.token);
      localStorage.setItem("hs_shop",JSON.stringify(shopData));
      localStorage.removeItem("hs_user");
      setRegForm({jina_duka:"",jina_mmiliki:"",email:"",password:"",simu:"",mahali:""});
      onLogin(shopData);
    }catch(e){setError(e.message||"Hitilafu ya seva");}
    setLoading(false);
  }

  return <div style={{minHeight:"100vh",background:"linear-gradient(160deg,var(--teal-l) 0%,white 50%)",
    display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"24px 20px"}}>
    <G/>
    {/* Logo */}
    <div style={{textAlign:"center",marginBottom:32}}>
      <div style={{width:64,height:64,background:"var(--teal)",borderRadius:18,
        display:"flex",alignItems:"center",justifyContent:"center",fontSize:30,
        margin:"0 auto 14px",boxShadow:"0 8px 24px rgba(13,148,136,.3)",overflow:"hidden",padding:0}}><img src="/icon-192.png" alt="HesabuSmart" style={{width:"100%",height:"100%",objectFit:"cover"}}/></div>
      <div style={{fontSize:26,fontWeight:900,color:"var(--teal)",letterSpacing:"-.5px"}}>Hesabu Smart</div>
      <div style={{fontSize:13,color:"var(--gray-400)",marginTop:4,fontWeight:500}}>Biashara Yako, Hesabu Yako</div>
    </div>

    {/* Tab switcher */}
    <div style={{display:"flex",background:"var(--gray-100)",borderRadius:12,padding:4,
      marginBottom:24,width:"100%",maxWidth:400}}>
      {[["login","Mmiliki"],["staff","Muuzaji"],["register","Jisajili"]].map(([v,l])=>(
        <button key={v} onClick={()=>{setView(v);setError("");}}
          style={{flex:1,padding:"10px",borderRadius:9,cursor:"pointer",fontWeight:700,
            fontSize:13,fontFamily:"var(--font)",border:"none",transition:"all .2s",
            background:view===v?"white":"transparent",
            color:view===v?"var(--teal)":"var(--gray-500)",
            boxShadow:view===v?"var(--sh)":"none"}}>{l}</button>
      ))}
    </div>

    <div style={{width:"100%",maxWidth:400}}>
      {error&&<div style={{background:"var(--red-l)",border:"1px solid #fecaca",borderRadius:"var(--r2)",
        padding:"11px 14px",marginBottom:14,fontSize:13,color:"var(--red)",fontWeight:600}}>{error}</div>}

      {view==="login"&&<div style={{display:"flex",flexDirection:"column",gap:4}}>
        <div style={{display:"flex",gap:8,marginBottom:8}}>
          <button type="button" onClick={()=>setLoginMethod("phone")}
            style={{flex:1,padding:"7px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,
              background:loginMethod==="phone"?"var(--teal)":"var(--gray-100)",
              color:loginMethod==="phone"?"#fff":"var(--gray-500)"}}>
            Simu
          </button>
          <button type="button" onClick={()=>setLoginMethod("email")}
            style={{flex:1,padding:"7px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,
              background:loginMethod==="email"?"var(--teal)":"var(--gray-100)",
              color:loginMethod==="email"?"#fff":"var(--gray-500)"}}>
            Barua Pepe
          </button>
        </div>
        <Inp label={loginMethod==="phone"?"Namba ya Simu":"Barua Pepe"} type={loginMethod==="phone"?"tel":"email"} value={loginForm.email}
          placeholder={loginMethod==="phone"?"0712345678":"duka@email.com"}
          onChange={e=>setLoginForm(f=>({...f,email:e.target.value}))} required/>
        <Inp label="Nywila" type="password" value={loginForm.password}
          onChange={e=>setLoginForm(f=>({...f,password:e.target.value}))}
          placeholder="••••••••" required/>
        <Btn v="primary" sz="lg" full onClick={doLogin} disabled={loading}
          style={{marginTop:8,background:"var(--teal)",boxShadow:"0 4px 14px rgba(13,148,136,.35)"}}>
          {loading?"Inasubiri...":"Ingia →"}
        </Btn>
      </div>}

      {view==="staff"&&<div style={{display:"flex",flexDirection:"column",gap:4}}>
        <div style={{background:"var(--teal-l)",border:"1px solid var(--teal-m)",borderRadius:"var(--r2)",
          padding:"11px 14px",marginBottom:8,fontSize:12,color:"var(--teal-d)",fontWeight:600}}>
          Ingia kama muuzaji — tumia simu na nywila uliyopewa na mmiliki
        </div>
        <Inp label="Nambari ya Simu" type="tel" value={staffForm.simu}
          onChange={e=>setStaffForm(f=>({...f,simu:e.target.value}))}
          placeholder="0712 345 678" required/>
        <Inp label="Nywila" type="password" value={staffForm.password}
          onChange={e=>setStaffForm(f=>({...f,password:e.target.value}))}
          placeholder="••••••••" required/>
        <Btn v="primary" sz="lg" full onClick={doStaffLogin} disabled={loading}
          style={{marginTop:8,background:"var(--teal)",boxShadow:"0 4px 14px rgba(13,148,136,.35)"}}>
          {loading?"Inasubiri...":"Ingia kama Muuzaji →"}
        </Btn>
      </div>}

      {view==="register"&&<div style={{display:"flex",flexDirection:"column",gap:4}}>
        <Inp label="Jina la Duka *" value={regForm.jina_duka}
          onChange={e=>setRegForm(f=>({...f,jina_duka:e.target.value}))} placeholder="Duka la Mama Amina" required/>
        <Inp label="Jina la Mmiliki *" value={regForm.jina_mmiliki}
          onChange={e=>setRegForm(f=>({...f,jina_mmiliki:e.target.value}))} placeholder="Amina Hassan" required/>
        <div style={{display:"flex",gap:8,marginBottom:4}}>
          <button type="button" onClick={()=>setRegMethod("phone")}
            style={{flex:1,padding:"7px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,
              background:regMethod==="phone"?"var(--teal)":"var(--gray-100)",
              color:regMethod==="phone"?"#fff":"var(--gray-500)"}}>
            📱 Simu
          </button>
          <button type="button" onClick={()=>setRegMethod("email")}
            style={{flex:1,padding:"7px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,
              background:regMethod==="email"?"var(--teal)":"var(--gray-100)",
              color:regMethod==="email"?"#fff":"var(--gray-500)"}}>
            📧 Barua Pepe
          </button>
        </div>
        {regMethod==="phone"
          ? <Inp label="Namba ya Simu *" type="tel" value={regForm.simu}
              onChange={e=>setRegForm(f=>({...f,simu:e.target.value}))} placeholder="0712345678" required/>
          : <Inp label="Barua Pepe *" type="email" value={regForm.email}
              onChange={e=>setRegForm(f=>({...f,email:e.target.value}))} placeholder="amina@duka.co.tz" required/>
        }
        <Inp label="Nywila *" type="password" value={regForm.password}
          onChange={e=>setRegForm(f=>({...f,password:e.target.value}))} placeholder="Herufi 6+" required/>
        <Inp label="Mahali" value={regForm.mahali}
          onChange={e=>setRegForm(f=>({...f,mahali:e.target.value}))} placeholder="Arusha"/>
        <Btn v="primary" sz="lg" full onClick={doRegister} disabled={loading}
          style={{marginTop:8,background:"var(--teal)",boxShadow:"0 4px 14px rgba(13,148,136,.35)"}}>
          {loading?"Inasajili...":"Jisajili Bure →"}
        </Btn>
        <div style={{fontSize:11,color:"var(--gray-400)",textAlign:"center",marginTop:8}}>
          Majaribio ya siku 14 · TZS 5,000/mwezi baadaye
        </div>
      </div>}
    </div>
  </div>;
}

/* ─── PRINT MODAL ─────────────────────────────────────────────────────────── */
function PrintModal({items,total,customer,onClose}){
  const [sz,setSz]=useState("80");
  const rc=formatReceipt(items,total,customer,sz);
  function doPrint(){
    const w=window.open("","_blank","width=400,height=600");
    w.document.write("<html><head><title>HesabuSmart</title><style>body{font-family:'Courier New',monospace;font-size:"+(sz==="58"?"11":"12")+"px;margin:0;padding:10px}pre{white-space:pre-wrap;margin:0}</style></head><body><pre>"+rc+"</pre><script>window.onload=function(){window.print()}<\/script></body></html>");
    w.document.close();
  }
  return <Modal title="Chapisha Risiti" onClose={onClose}>
    <div style={{display:"flex",gap:10,marginBottom:16}}>
      {[["58","58mm Mini"],["80","80mm Standard"]].map(([val,lbl])=>(
        <button key={val} onClick={()=>setSz(val)} style={{flex:1,padding:"10px",borderRadius:"var(--r2)",
          cursor:"pointer",fontWeight:700,fontSize:13,fontFamily:"var(--font)",
          border:"2px solid "+(sz===val?"var(--teal)":"var(--gray-200)"),
          background:sz===val?"var(--teal-l)":"white",
          color:sz===val?"var(--teal)":"var(--gray-500)"}}>{lbl}</button>
      ))}
    </div>
    <div style={{background:"var(--gray-50)",border:"1px solid var(--gray-200)",borderRadius:"var(--r2)",
      padding:14,marginBottom:14,maxHeight:240,overflowY:"auto"}}>
      <pre style={{fontFamily:"'Courier New',monospace",fontSize:sz==="58"?10:11,
        color:"var(--gray-800)",margin:0,whiteSpace:"pre-wrap",lineHeight:1.6}}>{rc}</pre>
    </div>
    <div style={{display:"flex",gap:10}}>
      <Btn v="primary" sz="lg" style={{flex:2}} onClick={doPrint}>Chapisha</Btn>
      <Btn v="secondary" sz="lg" style={{flex:1}} onClick={()=>navigator.clipboard.writeText(rc)}>Nakili</Btn>
    </div>
  </Modal>;
}

/* ─── SCANNER MODAL ───────────────────────────────────────────────────────── */
function ScanModal({onScan,onClose}){
  const [code,setCode]=useState("");
  const ref=useRef();
  useEffect(()=>ref.current?.focus(),[]);
  useEffect(()=>{
    let buf="",t=null;
    const fn=e=>{
      if(e.key==="Enter"&&buf.length>3){onScan(buf);buf="";return;}
      if(e.key.length===1){buf+=e.key;clearTimeout(t);t=setTimeout(()=>{buf=""},100);}
    };
    window.addEventListener("keydown",fn);
    return()=>{window.removeEventListener("keydown",fn);clearTimeout(t);};
  },[onScan]);
  return <Modal title="Scan Barcode" onClose={onClose}>
    <div style={{height:120,background:"var(--teal-l)",border:"2px dashed var(--teal-m)",
      borderRadius:"var(--r)",display:"flex",flexDirection:"column",alignItems:"center",
      justifyContent:"center",marginBottom:16,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",top:0,left:0,right:0,height:2,
        background:"linear-gradient(90deg,transparent,var(--teal),transparent)",
        animation:"scanLine 2s linear infinite"}}/>
      <div style={{fontSize:32}}>📷</div>
      <div style={{fontSize:12,color:"var(--teal-d)",marginTop:6,fontWeight:700}}>USB/BT Scanner Tayari</div>
    </div>
    <div style={{display:"flex",gap:10}}>
      <input ref={ref} value={code} onChange={e=>setCode(e.target.value)}
        onKeyDown={e=>e.key==="Enter"&&code.trim().length>3&&onScan(code.trim())}
        placeholder="Weka barcode..."
        style={{flex:1,padding:"12px 14px",border:"2px solid var(--gray-200)",
          borderRadius:"var(--r2)",fontSize:14,outline:"none"}}
        onFocus={e=>e.target.style.borderColor="var(--teal)"}
        onBlur={e=>e.target.style.borderColor="var(--gray-200)"}/>
      <Btn onClick={()=>code.trim().length>3&&onScan(code.trim())}>OK</Btn>
    </div>
  </Modal>;
}

/* ─── SHARED: PRODUCT SEARCH ─────────────────────────────────────────────── */
function ProdSearch({prods,onAdd,zeroLock,onScan}){
  const [search,setSearch]=useState("");
  const [showDrop,setShowDrop]=useState(false);
  const [activeIdx,setActiveIdx]=useState(-1);
  const sRef=useRef(),dRef=useRef();
  const filtered=search.length>0
    ?prods.filter(p=>p.name.toLowerCase().includes(search.toLowerCase())||
      (p.sku||"").toLowerCase().includes(search.toLowerCase())||
      (p.barcode||"").includes(search)).slice(0,7)
    :[];
  useEffect(()=>{setShowDrop(filtered.length>0);setActiveIdx(-1);},[search]);
  useEffect(()=>{
    const fn=e=>{if(dRef.current&&!dRef.current.contains(e.target)&&
      sRef.current&&!sRef.current.contains(e.target))setShowDrop(false);};
    document.addEventListener("mousedown",fn);return()=>document.removeEventListener("mousedown",fn);
  },[]);
  function handleKD(e){
    if(!showDrop)return;
    if(e.key==="ArrowDown"){e.preventDefault();setActiveIdx(i=>Math.min(i+1,filtered.length-1));}
    if(e.key==="ArrowUp"){e.preventDefault();setActiveIdx(i=>Math.max(i-1,0));}
    if(e.key==="Enter"&&activeIdx>=0){onAdd(filtered[activeIdx]);setSearch("");setShowDrop(false);}
    if(e.key==="Escape")setShowDrop(false);
  }
  return <div style={{position:"relative"}}>
    <div style={{display:"flex",gap:8}}>
      <div style={{position:"relative",flex:1}}>
        <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:"var(--gray-400)",fontSize:16}}>⌕</span>
        <input ref={sRef} value={search} onChange={e=>setSearch(e.target.value)}
          onKeyDown={handleKD} onFocus={()=>filtered.length>0&&setShowDrop(true)}
          placeholder="Jina, SKU, au barcode..."
          style={{width:"100%",padding:"12px 14px 12px 34px",border:"2px solid var(--teal)",
            borderRadius:"var(--r2)",fontSize:14,outline:"none",background:"var(--teal-l)"}}/>
      </div>
      {onScan&&<button onClick={onScan} style={{padding:"12px 14px",background:"var(--teal-l)",
        border:"2px solid var(--teal)",borderRadius:"var(--r2)",cursor:"pointer",fontSize:20}}>📷</button>}
    </div>
    {showDrop&&<div ref={dRef} style={{position:"absolute",top:"calc(100% + 5px)",left:0,right:0,
      background:"white",border:"1px solid var(--gray-200)",borderRadius:"var(--r)",
      zIndex:200,overflow:"hidden",boxShadow:"var(--sh3)",animation:"slideDown .15s ease"}}>
      {filtered.map((p,i)=><div key={p.id}
        onClick={()=>{onAdd(p);setSearch("");setShowDrop(false);sRef.current?.focus();}}
        style={{padding:"11px 14px",cursor:"pointer",display:"flex",justifyContent:"space-between",
          alignItems:"center",background:activeIdx===i?"var(--teal-l)":"white",
          borderBottom:"1px solid var(--gray-100)"}}
        onMouseEnter={e=>e.currentTarget.style.background="var(--teal-l)"}
        onMouseLeave={e=>e.currentTarget.style.background=activeIdx===i?"var(--teal-l)":"white"}>
        <div>
          <div style={{fontSize:13,fontWeight:600,display:"flex",alignItems:"center",gap:6}}>
            {p.name}
            {(p.stock===0||p.idadi===0)&&<Badge color="red">ZIMEISHA</Badge>}
            {(p.stock>0||p.idadi>0)&&(p.stock<=5||p.idadi<=5)&&<Badge color="amber">CHINI</Badge>}
          </div>
          <div style={{fontSize:11,color:"var(--gray-400)",marginTop:1}}>Zilizobaki: {p.stock||p.idadi||0}</div>
        </div>
        <div style={{textAlign:"right"}}>
          <div style={{fontSize:13,color:"var(--teal)",fontWeight:800}}>{fmt(p.price||p.bei_uuzaji)}</div>
        </div>
      </div>)}
    </div>}
  </div>;
}

/* ─── SHARED: CART LIST ──────────────────────────────────────────────────── */
function CartList({items,onUpdQty,onRemove}){
  if(items.length===0) return <div style={{textAlign:"center",padding:"28px 0",color:"var(--gray-300)"}}>
    <div style={{fontSize:36}}>🛒</div>
    <div style={{fontSize:13,marginTop:8,fontWeight:500}}>Bado hakuna bidhaa</div>
  </div>;
  const total=items.reduce((s,i)=>s+i.price*i.qty,0);
  return <div style={{display:"flex",flexDirection:"column",gap:8}}>
    {items.map((it,i)=><div key={it.id} style={{display:"grid",
      gridTemplateColumns:"18px 1fr auto auto",gap:8,alignItems:"center",
      padding:"10px 12px",background:"var(--gray-50)",borderRadius:"var(--r2)",
      border:"1px solid var(--gray-100)"}}>
      <div style={{fontSize:10,color:"var(--gray-400)",fontWeight:700}}>{i+1}</div>
      <div>
        <div style={{fontSize:13,fontWeight:600}}>{it.name}</div>
        <div style={{fontSize:11,color:"var(--gray-400)",marginTop:1}}>{fmt(it.price)} / {it.unit||"pcs"}</div>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:4}}>
        {["−","+"].map((b,bi)=><button key={b}
          onClick={()=>onUpdQty(it.id,bi===0?it.qty-1:it.qty+1)}
          style={{width:28,height:28,background:"white",border:"1px solid var(--gray-200)",
            borderRadius:6,cursor:"pointer",fontSize:15,display:"flex",
            alignItems:"center",justifyContent:"center",fontWeight:700}}>{b}</button>)}
        <input type="number" min="1" value={it.qty}
          onChange={e=>onUpdQty(it.id,parseInt(e.target.value))}
          style={{width:42,textAlign:"center",border:"1px solid var(--teal)",borderRadius:6,
            padding:"3px 0",fontSize:13,color:"var(--teal)",fontWeight:700,outline:"none",
            background:"var(--teal-l)"}}/>
      </div>
      <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4}}>
        <div style={{fontSize:13,fontWeight:800}}>{fmt(it.price*it.qty)}</div>
        <button onClick={()=>onRemove(it.id)}
          style={{background:"none",border:"none",color:"var(--gray-300)",cursor:"pointer",fontSize:18}}>×</button>
      </div>
    </div>)}
    <div style={{padding:"12px 14px",background:"var(--teal)",borderRadius:"var(--r2)",
      display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:4}}>
      <div style={{fontSize:12,color:"rgba(255,255,255,.7)"}}>{items.length} bidhaa · {items.reduce((s,i)=>s+i.qty,0)} vipande</div>
      <div style={{fontSize:20,fontWeight:900,color:"white"}}>{fmt(total)}</div>
    </div>
  </div>;
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/* ─── TAB: NYUMBANI ──────────────────────────────────────────────────────── */
function TabNyumbani({shop}){
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    api.dashboard().then(d=>setData(d)).catch(()=>setData(null)).finally(()=>setLoading(false));
  },[]);

  if(loading) return <Spinner/>;

  const d = data || {};

  const maxAmt=Math.max(...(d.sales_chart||[]).map(x=>x.total||x.amt||0),1);
  const DAYS=["Jtu","Jnn","Jma","Alh","Iju","Ijm","Jpi"];

  return <div>
    <div className="fu" style={{marginBottom:18}}>
      <div style={{fontSize:20,fontWeight:900,letterSpacing:"-.5px"}}>Habari, {shop?.owner_name||shop?.name||"Rafiki"} 👋</div>
      <div style={{fontSize:12,color:"var(--gray-400)",marginTop:3,fontWeight:500}}>{todayStr()}</div>
    </div>

    <div className="fu" style={{background:"linear-gradient(135deg,var(--teal),var(--teal-d))",
      borderRadius:"var(--r)",padding:"20px",color:"white",marginBottom:12,
      boxShadow:"0 6px 20px rgba(13,148,136,.3)"}}>
      <div style={{fontSize:10,fontWeight:700,opacity:.75,textTransform:"uppercase",letterSpacing:1.2,marginBottom:8}}>Mauzo Leo</div>
      <div style={{fontSize:32,fontWeight:900,letterSpacing:"-1px"}}>{fmt(d.today_sales)}</div>
      <div style={{fontSize:12,opacity:.7,marginTop:6}}>{d.today_count||0} miamala leo</div>
    </div>

    <div className="grid2 fu1" style={{marginBottom:12}}>
      {[
        {l:"Mapato Mwezi",v:fmt(d.month_sales),c:"var(--teal)",ic:"📈"},
        {l:"Faida (Est.)",v:fmt(Math.max(0,d.net_profit||0)),c:"var(--green)",ic:"💰"},
        {l:"Madeni",v:fmt(d.unpaid_debts),c:"var(--red)",ic:"📒"},
        {l:"Zimeisha",v:d.out_of_stock||0,c:"var(--amber)",ic:"📦"},
      ].map((k,i)=><Card key={i} style={{padding:"14px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
          <div style={{fontSize:10,fontWeight:700,color:"var(--gray-400)",textTransform:"uppercase",letterSpacing:.8}}>{k.l}</div>
          <span style={{fontSize:18}}>{k.ic}</span>
        </div>
        <div style={{fontSize:18,fontWeight:900,color:k.c,lineHeight:1}}>{k.v}</div>
      </Card>)}
    </div>

    {/* Chart */}
    {(d.sales_chart||[]).length>0&&<Card className="fu2" style={{marginBottom:12}}>
      <div style={{fontSize:13,fontWeight:800,marginBottom:12}}>Mauzo — Siku 7</div>
      <div style={{display:"flex",alignItems:"flex-end",gap:6,height:70}}>
        {(d.sales_chart||[]).map((x,i)=>{
          const amt=x.total||x.amt||0;
          const pct=(amt/maxAmt)*100;
          const isT=i===(d.sales_chart.length-1);
          const day=DAYS[i]||x.date?.slice(5,10)||"";
          return <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
            <div style={{width:"100%",height:pct+"%",minHeight:4,
              background:isT?"var(--teal)":"var(--teal-m)",borderRadius:"4px 4px 0 0"}}/>
            <div style={{fontSize:9,color:isT?"var(--teal)":"var(--gray-400)",fontWeight:isT?800:500}}>{day}</div>
          </div>;
        })}
      </div>
    </Card>}

    {/* Low stock alert */}
    {(d.low_stock||[]).length>0&&<Card className="fu3" style={{background:"var(--amber-l)",border:"1px solid #fde68a",marginBottom:12}}>
      <div style={{fontSize:12,fontWeight:800,color:"#92400e",marginBottom:8}}>⚠️ Bidhaa Zinazokwisha</div>
      {d.low_stock.map((p,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",
        padding:"5px 0",borderBottom:"1px solid #fde68a",fontSize:12}}>
        <span style={{fontWeight:500}}>{p.name||p.jina}</span>
        <span style={{color:"var(--red)",fontWeight:800}}>Salio: {p.stock||p.idadi}</span>
      </div>)}
    </Card>}

    {/* Recent sales */}
    {(d.recent_sales||[]).length>0&&<Card className="fu4">
      <div style={{fontSize:13,fontWeight:800,marginBottom:12}}>Mauzo ya Hivi Karibuni</div>
      {d.recent_sales.map((s,i)=><div key={s.id||i} style={{display:"flex",justifyContent:"space-between",
        alignItems:"center",padding:"8px 0",borderBottom:"1px solid var(--gray-100)"}}>
        <div>
          <div style={{fontSize:12,fontWeight:700}}>{(s.items||[]).map(x=>x.name).join(", ").slice(0,35)||s.maelezo||""}</div>
          <div style={{display:"flex",gap:6,alignItems:"center",marginTop:2}}>
            <span style={{fontSize:10,color:"var(--gray-400)"}}>{s.created_at?new Date(s.created_at).toLocaleString("sw-TZ",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"}):""}</span>
            {s.customer&&<span style={{fontSize:10,color:"var(--gray-500)"}}>· {s.customer}</span>}
            <Badge color={s.payment_mode==="Cash"||s.njia_malipo==="cash"?"green":s.payment_mode==="Mkopo"?"amber":"teal"}>{s.payment_mode||s.njia_malipo||"Cash"}</Badge>
          </div>
        </div>
        <div style={{fontSize:13,fontWeight:800,color:"var(--teal)"}}>{fmt(s.total||s.kiasi)}</div>
      </div>)}
    </Card>}
  </div>;
}

/* ─── TAB: MAUZO ─────────────────────────────────────────────────────────── */
function TabMauzo({prods,setProds,zeroLock,payModes,onToast,onScan,onPrint}){
  const [cart,setCart]=useState([]);
  const [payMode,setPayMode]=useState("Cash");
  const [customer,setCustomer]=useState("");
  const [sales,setSales]=useState([]);
  const [view,setView]=useState("pos");
  const [orders,setOrders]=useState([]);
  const [loadingOrders,setLoadingOrders]=useState(false);
  const [fulfillId,setFulfillId]=useState(null);
  const [fulfillPay,setFulfillPay]=useState("cash");
  const [saving,setSaving]=useState(false);
  const [tendered,setTendered]=useState("");
  const [catFilter,setCatFilter]=useState("Yote");

  useEffect(()=>{
    if(view==="history") api.sales.list().then(setSales).catch(()=>{});
    if(view==="oda"){
      setLoadingOrders(true);
      api.orders.list().then(setOrders).catch(()=>{}).finally(()=>setLoadingOrders(false));
    }
  },[view]);

  const filteredProds = catFilter==="Yote" ? prods : prods.filter(p=>(p.category||p.cat||"Nyingine")===catFilter);

  function addToCart(p){
    const stock=p.stock??p.idadi??0;
    const price=p.price||p.bei_uuzaji||0;
    const name=p.name||p.jina||"";
    if(zeroLock&&stock===0){onToast("Hakuna stoki: "+name,"error");return;}
    setCart(prev=>{
      const ex=prev.find(i=>i.id===p.id);
      if(ex){const nq=ex.qty+1;if(zeroLock&&nq>stock){onToast("Zilizobaki: "+stock+" tu","warn");return prev;}
        return prev.map(i=>i.id===p.id?{...i,qty:nq}:i);}
      return [...prev,{id:p.id,name,price,unit:p.unit||"pcs",qty:1,stock}];
    });
  }

  function updQty(id,n){
    if(isNaN(n)||n<1)return;
    const it=cart.find(x=>x.id===id);
    if(zeroLock&&it&&n>it.stock){onToast("Zilizobaki: "+it.stock+" tu","warn");return;}
    setCart(prev=>prev.map(i=>i.id===id?{...i,qty:n}:i));
  }

  const total=cart.reduce((s,i)=>s+i.price*i.qty,0);

  async function doSell(){
    if(saving){return;}
    if(cart.length===0){onToast("Ongeza bidhaa kwanza","error");return;}
    if(payMode==="Mkopo"&&!customer){onToast("Weka jina la mteja kwa mkopo","error");return;}
    setSaving(true);
    try{
      await api.sales.create({
        maelezo: cart.map(i=>i.name+" x"+i.qty).join(", "),
        kiasi: total,
        njia_malipo: payMode.toLowerCase(),
        items: cart.map(i=>({product_id:i.id,name:i.name,qty:i.qty,price:i.price})),
        customer,
      });
      // Update local stock
      setProds(prev=>prev.map(p=>{
        const ci=cart.find(c=>c.id===p.id);
        if(!ci)return p;
        return {...p,stock:Math.max(0,(p.stock||p.idadi||0)-ci.qty),idadi:Math.max(0,(p.idadi||p.stock||0)-ci.qty)};
      }));
      onToast("Umeuzwa "+fmt(total)+" — "+payMode,"success");
      setCart([]);setCustomer("");setPayMode("Cash");setTendered("");
    }catch(e){onToast(e.message,"error");}
    setSaving(false);
  }

  return <div>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
      <div style={{fontSize:18,fontWeight:900}}>Mauzo (POS)</div>
      <div style={{display:"flex",gap:8}}>
        {[["pos","POS"],["history","Historia"],["oda","Oda"]].map(([val,lbl])=>(
          <button key={val} onClick={()=>setView(val)} style={{padding:"7px 16px",borderRadius:20,
            cursor:"pointer",fontWeight:700,fontSize:12,fontFamily:"var(--font)",
            border:"2px solid "+(view===val?"var(--teal)":"var(--gray-200)"),
            background:view===val?"var(--teal)":"white",color:view===val?"white":"var(--gray-500)"}}>{lbl}</button>
        ))}
      </div>
    </div>

    {view==="pos"&&<div style={{display:"flex",flexDirection:"column",gap:14}}>
      <Card>
        <STitle>Tafuta Bidhaa</STitle>
        <ProdSearch prods={filteredProds} onAdd={addToCart} zeroLock={zeroLock} onScan={onScan}/>
        {/* Category filter */}
        <div style={{display:"flex",gap:6,marginTop:10,flexWrap:"wrap"}}>
          {["Yote",...new Set(prods.map(p=>p.category||p.cat||"").filter(Boolean))].map(k=>(
            <button key={k} onClick={()=>setCatFilter(k)}
              style={{padding:"5px 12px",borderRadius:20,cursor:"pointer",
                fontSize:11,fontWeight:700,fontFamily:"var(--font)",
                border:"2px solid "+(catFilter===k?"var(--teal)":"var(--gray-200)"),
                background:catFilter===k?"var(--teal)":"white",
                color:catFilter===k?"white":"var(--gray-600)"}}>{k}</button>
          ))}
        </div>
        {/* Product grid for selected category */}
        {catFilter!=="Yote"&&<div style={{marginTop:10,display:"flex",flexDirection:"column",gap:6,maxHeight:220,overflowY:"auto"}}>
          {filteredProds.map(p=>{
            const stock=p.stock||p.idadi||0;
            const price=p.price||p.bei_uuzaji||0;
            const name=p.name||p.jina||"";
            const disabled=zeroLock&&stock===0;
            return <div key={p.id} onClick={()=>!disabled&&addToCart(p)}
              style={{display:"flex",justifyContent:"space-between",alignItems:"center",
                padding:"8px 10px",borderRadius:"var(--r2)",cursor:disabled?"not-allowed":"pointer",
                background:disabled?"var(--gray-50)":"var(--teal-l)",
                border:"1px solid "+(disabled?"var(--gray-200)":"var(--teal-m)"),
                opacity:disabled?.5:1}}>
              <div>
                <div style={{fontSize:12,fontWeight:700,color:disabled?"var(--gray-400)":"var(--gray-800)"}}>{name}</div>
                <div style={{fontSize:10,color:"var(--gray-400)"}}>Zilizobaki: {stock}</div>
              </div>
              <div style={{fontSize:13,fontWeight:800,color:"var(--teal)"}}>{fmt(price)}</div>
            </div>;
          })}
          {filteredProds.length===0&&<div style={{fontSize:12,color:"var(--gray-400)",textAlign:"center",padding:10}}>Hakuna bidhaa katika kundi hili</div>}
        </div>}
      </Card>
      <Card>
        <STitle>Bidhaa Kwenye Mauzo ({cart.length})</STitle>
        <CartList items={cart} onUpdQty={updQty} onRemove={id=>setCart(p=>p.filter(x=>x.id!==id))}/>
      </Card>
      {cart.length>0&&<Card>
        <STitle>Njia ya Malipo</STitle>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:14}}>
          {(payModes||["Cash","M-Pesa","Airtel","Tigo","Mkopo"]).map(p=>(
            <button key={p} onClick={()=>setPayMode(p)} style={{padding:"10px 6px",borderRadius:"var(--r2)",
              cursor:"pointer",fontWeight:700,fontSize:12,fontFamily:"var(--font)",
              border:"2px solid "+(payMode===p?(PAY_COLORS[p]||"var(--teal)"):"var(--gray-200)"),
              background:payMode===p?((PAY_COLORS[p]||"var(--teal)")+"18"):"white",
              color:payMode===p?(PAY_COLORS[p]||"var(--teal)"):"var(--gray-500)"}}>{p}</button>
          ))}
        </div>
        {payMode==="Mkopo"&&<Inp label="Jina la Mteja" value={customer}
          onChange={e=>setCustomer(e.target.value)} placeholder="Jina la mteja" required/>}
      </Card>}
      {cart.length>0&&<div style={{background:"linear-gradient(135deg,var(--teal),var(--teal-d))",
        borderRadius:"var(--r)",padding:"16px 18px",
        display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{color:"rgba(255,255,255,.7)",fontSize:12}}>Jumla ya Kulipa</div>
        <div style={{fontSize:26,fontWeight:900,color:"white"}}>{fmt(total)}</div>
      </div>}
         {cart.length>0&&<Card>
        <STitle>Fedha Iliyotolewa</STitle>
        <Inp label="Kiasi Kilichotolewa (TZS)" type="number" value={tendered}
          onChange={e=>setTendered(e.target.value)} placeholder={String(total)}/>
        {tendered&&Number(tendered)>=total&&<div style={{background:"var(--green-l)",
          border:"1px solid #a7f3d0",borderRadius:"var(--r2)",padding:"12px 16px",
          display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8}}>
          <div style={{fontSize:13,fontWeight:700,color:"var(--green)"}}>Chenji</div>
          <div style={{fontSize:22,fontWeight:900,color:"var(--green)"}}>{fmt(Number(tendered)-total)}</div>
        </div>}
        {tendered&&Number(tendered)<total&&<div style={{background:"var(--red-l)",
          border:"1px solid #fecaca",borderRadius:"var(--r2)",padding:"12px 16px",
          display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8}}>
          <div style={{fontSize:13,fontWeight:700,color:"var(--red)"}}>Pungufu</div>
          <div style={{fontSize:22,fontWeight:900,color:"var(--red)"}}>{fmt(total-Number(tendered))}</div>
        </div>}
      </Card>}
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        <Btn v="primary" sz="lg" full onClick={doSell} disabled={cart.length===0||saving}
          style={cart.length>0?{background:"var(--green)",boxShadow:"0 4px 14px rgba(16,185,129,.3)"}:{}}>
          {saving?"Inasalimisha...":"✓ Kamilisha Mauzo — "+fmt(total)}
        </Btn>
        {cart.length>0&&<Btn v="outline" sz="md" full onClick={()=>onPrint({items:cart,total,customer})}>
          🖨️ Chapisha Risiti
        </Btn>}
        {cart.length>0&&<Btn v="danger" sz="md" full onClick={()=>{setCart([]);setCustomer("");setPayMode("Cash");setTendered("");}}>
          Futa
        </Btn>}
      </div>
    </div>}

    {view==="history"&&<Card>
      <div style={{fontSize:13,fontWeight:800,marginBottom:14}}>Historia ya Mauzo — Leo</div>
      {sales.length===0
        ?<div style={{textAlign:"center",padding:32,color:"var(--gray-300)"}}>
            <div style={{fontSize:32}}>📋</div><div style={{fontSize:13,marginTop:8}}>Hakuna mauzo bado</div>
          </div>
        :sales.map((s,i)=><div key={s.id||i} style={{padding:"11px 0",borderBottom:"1px solid var(--gray-100)",
          display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:12,fontWeight:700,marginBottom:3}}>{s.maelezo||"—"}</div>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <span style={{fontSize:10,color:"var(--gray-400)"}}>{new Date(s.created_at).toLocaleString("sw-TZ",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"})}</span>
              <Badge color={s.njia_malipo==="cash"?"green":s.njia_malipo==="mkopo"?"amber":"teal"}>{s.njia_malipo||"cash"}</Badge>
            </div>
          </div>
          <div style={{fontSize:14,fontWeight:800,color:"var(--teal)"}}>{fmt(s.kiasi)}</div>
        </div>)}
      <div style={{padding:"12px 0",display:"flex",justifyContent:"space-between",
        marginTop:4,borderTop:"2px solid var(--gray-200)"}}>
        <div style={{fontSize:12,fontWeight:700,color:"var(--gray-600)"}}>{sales.length} miamala</div>
        <div style={{fontSize:16,fontWeight:900,color:"var(--teal)"}}>{fmt(sales.reduce((s,x)=>s+(x.kiasi||0),0))}</div>
      </div>
    </Card>}

    {view==="oda"&&<div>
      <div style={{fontSize:13,fontWeight:800,marginBottom:14}}>Oda Zinazosub iri</div>
      {fulfillId&&<Modal title="Timiza Oda" onClose={()=>setFulfillId(null)}>
        <div style={{marginBottom:14,fontSize:13,color:"var(--gray-600)"}}>Chagua njia ya malipo:</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:18}}>
          {["cash","mpesa","airtel","tigo","mkopo"].map(p=>(
            <button key={p} onClick={()=>setFulfillPay(p)} style={{padding:"10px 6px",borderRadius:"var(--r2)",
              cursor:"pointer",fontWeight:700,fontSize:12,fontFamily:"var(--font)",
              border:"2px solid "+(fulfillPay===p?"var(--teal)":"var(--gray-200)"),
              background:fulfillPay===p?"var(--teal-l)":"white",
              color:fulfillPay===p?"var(--teal)":"var(--gray-500)",
              textTransform:"capitalize"}}>{p}</button>
          ))}
        </div>
        <Btn v="success" sz="lg" full onClick={async()=>{
          try{
            const r=await api.orders.fulfill(fulfillId,fulfillPay);
            onToast("Oda imekamilika! "+fmt(r.jumla),"success");
            setFulfillId(null);
            api.orders.list().then(setOrders).catch(()=>{});
          }catch(e){onToast(e.message,"error");}
        }}>✓ Timiza — Kamilisha Mauzo</Btn>
      </Modal>}
      {loadingOrders?<Spinner/>:orders.length===0
        ?<div style={{textAlign:"center",padding:32,color:"var(--gray-300)"}}>
            <div style={{fontSize:32}}>📋</div>
            <div style={{fontSize:13,marginTop:8}}>Hakuna oda zinazosub iri</div>
          </div>
        :<div style={{display:"flex",flexDirection:"column",gap:10}}>
          {orders.map(o=>{
            const items=o.bidhaa||[];
            const haliColor={inasubiri:"var(--amber)",imekamilika:"var(--green)",imefutwa:"var(--red)"}[o.hali]||"var(--gray-400)";
            return <Card key={o.id} style={{borderLeft:"3px solid "+haliColor}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:6,flexWrap:"wrap"}}>
                    <span style={{fontSize:13,fontWeight:900,color:"var(--teal)"}}>{o.namba}</span>
                    <Badge color={o.hali==="inasubiri"?"amber":o.hali==="imekamilika"?"green":"red"}>
                      {o.hali==="inasubiri"?"INASUBIRI":o.hali==="imekamilika"?"IMEKAMILIKA":"IMEFUTWA"}
                    </Badge>
                  </div>
                  {o.jina_mteja&&<div style={{fontSize:13,fontWeight:700,marginBottom:3}}>{o.jina_mteja}</div>}
                  {o.simu_mteja&&<div style={{fontSize:11,color:"var(--gray-400)",marginBottom:4}}>{o.simu_mteja}</div>}
                  <div style={{fontSize:11,color:"var(--gray-500)"}}>
                    {items.filter(i=>i&&i.jina).map(i=>i.jina+" x"+i.idadi).join(" · ").slice(0,60)}
                  </div>
                  <div style={{fontSize:10,color:"var(--gray-400)",marginTop:4}}>
                    {new Date(o.created_at).toLocaleString("sw-TZ",{day:"2-digit",month:"short",hour:"2-digit",minute:"2-digit"})}
                  </div>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:6,alignItems:"flex-end",flexShrink:0}}>
                  <div style={{fontSize:16,fontWeight:900,color:"var(--teal)"}}>{fmt(o.jumla)}</div>
                  {o.hali==="inasubiri"&&<div style={{display:"flex",gap:6}}>
                    <Btn v="success" sz="sm" onClick={()=>{setFulfillId(o.id);setFulfillPay("cash");}}>
                      ✓ Timiza
                    </Btn>
                    <Btn v="danger" sz="sm" onClick={async()=>{
                      try{
                        await api.orders.cancel(o.id);
                        onToast("Oda imefutwa","warn");
                        api.orders.list().then(setOrders).catch(()=>{});
                      }catch(e){onToast(e.message,"error");}
                    }}>✕</Btn>
                  </div>}
                  {o.hali==="inasubiri"&&o.simu_mteja&&<Btn v="wa" sz="sm" onClick={()=>{
                    const ph=o.simu_mteja.replace(/\D/g,"").replace(/^0/,"");
                    const msg="Habari "+( o.jina_mteja||"")+" ,\nOda yako *"+o.namba+"* iko tayari!\nJumla: *"+fmt(o.jumla)+"*\nAsante — hesabusmart.co.tz";
                    window.open("https://wa.me/255"+ph+"?text="+encodeURIComponent(msg),"_blank");
                  }}>WA</Btn>}
                </div>
              </div>
            </Card>;
          })}
        </div>}
    </div>}
  </div>;
}

/* ─── TAB: BIDHAA ─────────────────────────────────────────────────────────── */

function CsvUploadModal({onClose, onSuccess, onToast}){
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState([]);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  function parseCSV(text){
    const lines = text.trim().split('\n');
    if(lines.length < 2) return [];
    const headers = lines[0].split(',').map(h=>h.trim().toLowerCase().replace(/\s+/g,'_').replace(/[^a-z_]/g,''));
    return lines.slice(1).map(line=>{
      const vals = line.split(',').map(v=>v.trim().replace(/^"|"$/g,''));
      const obj = {};
      headers.forEach((h,i)=>{ obj[h]=vals[i]||''; });
      return obj;
    }).filter(r=>r.jina||r.name);
  }

  function handleFile(f){
    if(!f) return;
    setFile(f); setResult(null); setError('');
    const reader = new FileReader();
    reader.onload = e=>{
      const rows = parseCSV(e.target.result);
      if(rows.length===0){setError('Faili haina data au muundo si sahihi');return;}
      setPreview(rows.slice(0,5));
    };
    reader.readAsText(f);
  }

  async function doUpload(){
    if(!file){setError('Chagua faili kwanza');return;}
    setLoading(true); setError('');
    const reader = new FileReader();
    reader.onload = async e=>{
      const products = parseCSV(e.target.result);
      try{
        const res = await apiFetch('/bidhaa/upload-csv',{method:'POST',body:JSON.stringify({products})});
        setResult(res);
        onSuccess();
      }catch(err){setError(err.message);}
      setLoading(false);
    };
    reader.readAsText(file);
  }

  function downloadTemplate(){
    const csv = "jina,bei_uuzaji,bei_ununuzi,idadi,kiwango_chini,unit,category,sku\nSlide Pink Size 37,25000,18000,5,2,pcs,Slides,SLD-PNK-37\nSlide Pink Size 38,25000,18000,3,2,pcs,Slides,SLD-PNK-38\nCrocs Classic Black Size 40,35000,25000,4,2,pcs,Crocs,CRC-BLK-40";
    const blob = new Blob([csv],{type:'text/csv'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href=url; a.download='bidhaa_template.csv'; a.click();
    URL.revokeObjectURL(url);
  }

  return(
    <Modal title="Pakia Bidhaa kwa CSV" onClose={onClose}>
      <div style={{background:"var(--teal-l)",border:"1px solid var(--teal)",borderRadius:"var(--r2)",
        padding:"12px 14px",marginBottom:16,fontSize:13}}>
        <div style={{fontWeight:700,color:"var(--teal)",marginBottom:4}}>Jinsi ya kutumia:</div>
        <div style={{color:"var(--gray-600)",lineHeight:1.6}}>
          1. Pakua template ya CSV hapa chini<br/>
          2. Jaza bidhaa zako kwenye Excel au Google Sheets<br/>
          3. Hifadhi kama CSV na pakia hapa
        </div>
        <button onClick={downloadTemplate}
          style={{marginTop:8,padding:"6px 14px",background:"var(--teal)",color:"white",
            border:"none",borderRadius:6,cursor:"pointer",fontWeight:700,fontSize:12}}>
          ⬇ Pakua Template
        </button>
      </div>

      <div onDragOver={e=>e.preventDefault()}
        onDrop={e=>{e.preventDefault();handleFile(e.dataTransfer.files[0]);}}
        style={{border:"2px dashed var(--gray-200)",borderRadius:"var(--r2)",padding:"24px",
          textAlign:"center",marginBottom:16,cursor:"pointer",background:"var(--gray-50)"}}
        onClick={()=>document.getElementById('csv-input').click()}>
        <input id="csv-input" type="file" accept=".csv" style={{display:"none"}}
          onChange={e=>handleFile(e.target.files[0])}/>
        <div style={{fontSize:24,marginBottom:8}}>📄</div>
        <div style={{fontSize:13,fontWeight:600,color:"var(--gray-600)"}}>
          {file ? file.name : "Bonyeza au vuta faili ya CSV hapa"}
        </div>
        {file&&<div style={{fontSize:11,color:"var(--teal)",marginTop:4}}>✓ Faili imechaguliwa</div>}
      </div>

      {preview.length>0&&<div style={{marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,color:"var(--gray-500)",marginBottom:6,textTransform:"uppercase"}}>
          Mfano wa bidhaa ({preview.length} za kwanza):
        </div>
        {preview.map((p,i)=>(
          <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"6px 10px",
            background:"var(--gray-50)",borderRadius:6,marginBottom:4,fontSize:12}}>
            <span style={{fontWeight:600}}>{p.jina||p.name}</span>
            <span style={{color:"var(--teal)"}}>TZS {Number(p.bei_uuzaji||p.price||0).toLocaleString()}</span>
            <span style={{color:"var(--gray-400)"}}>{p.category||p.kundi||"Nyingine"}</span>
          </div>
        ))}
      </div>}

      {error&&<div style={{background:"var(--red-l)",border:"1px solid #fecaca",borderRadius:"var(--r2)",
        padding:"10px 14px",marginBottom:12,fontSize:13,color:"var(--red)"}}>{error}</div>}

      {result&&<div style={{background:"var(--green-l)",border:"1px solid #a7f3d0",borderRadius:"var(--r2)",
        padding:"12px 14px",marginBottom:12,fontSize:13}}>
        <div style={{fontWeight:700,color:"var(--green)",marginBottom:4}}>✓ {result.message}</div>
        {result.failed>0&&<div style={{color:"var(--amber)"}}>Zilishindwa: {result.failed}</div>}
        {result.errors?.slice(0,3).map((e,i)=><div key={i} style={{fontSize:11,color:"var(--gray-500)"}}>{e}</div>)}
      </div>}

      {!result&&<Btn v="primary" sz="lg" full onClick={doUpload} disabled={loading||!file}>
        {loading?"Inapakia...":"Ingiza Bidhaa"}
      </Btn>}
      {result&&<Btn v="secondary" sz="lg" full onClick={onClose}>Funga</Btn>}
    </Modal>
  );
}

function TabBidhaa({prods,setProds,zeroLock,setZeroLock,onToast,onScan,isOwner}){
  const [cats,setCats]=useState([]);
  const [showCats,setShowCats]=useState(false);
  const [showCsvUpload,setShowCsvUpload]=useState(false);
  const [newCat,setNewCat]=useState("");
  const [catsLoading,setCatsLoading]=useState(false);
  useEffect(()=>{
    api.products.categories.list().then(setCats).catch(()=>{});
  },[]);
  async function addCat(){
    if(!newCat.trim()){return;}
    setCatsLoading(true);
    try{
      const r=await api.products.categories.create(newCat.trim());
      setCats(p=>[...p,r]);setNewCat("");
    }catch(e){}
    setCatsLoading(false);
  }
  async function deleteCat(id){
    try{
      await api.products.categories.remove(id);
      setCats(p=>p.filter(c=>c.id!==id));
    }catch(e){}
  }
  const [selected,setSelected]=useState([]);
  const toggleSel=(id)=>setSelected(p=>p.includes(id)?p.filter(x=>x!==id):[...p,id]);
  async function deleteSelected(){
    if(!selected.length)return;
    if(!window.confirm("Futa bidhaa "+selected.length+"? Haiwezi kurudishwa."))return;
    try{
      await Promise.all(selected.map(id=>api.products.remove(id)));
      setProds(p=>p.filter(x=>!selected.includes(x.id)));
      setSelected([]);
      onToast("Bidhaa "+selected.length+" zimefutwa","warn");
    }catch(e){onToast(e.message,"error");}
  }
  async function deleteSingle(id){
    if(!window.confirm("Futa bidhaa hii?"))return;
    try{
      await api.products.remove(id);
      setProds(p=>p.filter(x=>x.id!==id));
      onToast("Imefutwa","warn");
    }catch(e){onToast(e.message,"error");}
  }
  const [search,setSearch]=useState("");
  const [editId,setEditId]=useState(null);
  const [editForm,setEditForm]=useState({jina:"",price:"",stock:"",min_stock:""});
  const [showAdd,setShowAdd]=useState(false);
  const [loading,setLoading]=useState(false);
  const [form,setForm]=useState({jina:"",sku:"",barcode:"",bei_uuzaji:"",bei_ununuzi:"",idadi:"",min_stock:"5",unit:"pcs",category:"Nyingine"});

  const filtered=prods.filter(p=>{
    const name=(p.name||p.jina||"").toLowerCase();
    const sku=(p.sku||"").toLowerCase();
    const bc=(p.barcode||"");
    const s=search.toLowerCase();
    return name.includes(s)||sku.includes(s)||bc.includes(s);
  });

  async function saveStock(id){
    const v=parseInt(document.getElementById("s"+id)?.value);
    if(isNaN(v)||v<0)return;
    try{
      await api.products.updateStock(id,v);
      setProds(prev=>prev.map(p=>p.id===id?{...p,stock:v,idadi:v}:p));
      setEditId(null);onToast("Idadi imesasishwa","success");
    }catch(e){onToast(e.message,"error");}
  }

  async function addProduct(){
    if(!form.jina||!form.bei_uuzaji){onToast("Jaza jina na bei","error");return;}
    setLoading(true);
    try{
      const p=await api.products.create({
        jina:form.jina,sku:form.sku,barcode:form.barcode,
        bei_uuzaji:parseFloat(form.bei_uuzaji)||0,
        bei_ununuzi:parseFloat(form.bei_ununuzi)||0,
        idadi:parseInt(form.idadi)||0,
        min_stock:parseInt(form.min_stock)||5,
        unit:form.unit,category:form.category,
      });
      setProds(prev=>[{...p,name:p.jina||p.name,price:p.bei_uuzaji||p.price,stock:p.idadi||p.stock||0},...prev]);
      setForm({jina:"",sku:"",barcode:"",bei_uuzaji:"",bei_ununuzi:"",idadi:"",min_stock:"5",unit:"pcs",category:"Nyingine"});
      setShowAdd(false);onToast("Bidhaa imeongezwa","success");
    }catch(e){onToast(e.message,"error");}
    setLoading(false);
  }

  return <div>
    {showCsvUpload&&<CsvUploadModal onClose={()=>setShowCsvUpload(false)}
      onSuccess={()=>{apiFetch("/bidhaa?t="+Date.now()).then(list=>setProds(list.map(p=>({...p,name:p.jina||p.name,price:p.bei_uuzaji||p.price,stock:p.idadi||p.stock||0})))).catch(()=>{});setShowCsvUpload(false);}}
      onToast={onToast}/>}
    {showAdd&&<Modal title="Ongeza Bidhaa Mpya" onClose={()=>setShowAdd(false)}>
      <Inp label="Jina *" value={form.jina} onChange={e=>setForm(f=>({...f,jina:e.target.value}))} placeholder="Unga wa Ngano 2kg" required/>
      <div className="grid2" style={{gap:"0 14px"}}>
        <Inp label="SKU" value={form.sku} onChange={e=>setForm(f=>({...f,sku:e.target.value}))} placeholder="UNG-2KG"/>
        <Inp label="Barcode" value={form.barcode} onChange={e=>setForm(f=>({...f,barcode:e.target.value}))} placeholder="6001234..."/>
        <Inp label="Bei ya Kuuza *" type="number" value={form.bei_uuzaji} onChange={e=>setForm(f=>({...f,bei_uuzaji:e.target.value}))} placeholder="4500" required/>
        <Inp label="Bei ya Kununua" type="number" value={form.bei_ununuzi} onChange={e=>setForm(f=>({...f,bei_ununuzi:e.target.value}))} placeholder="3800"/>
        <Inp label="Kiasi cha Awali" type="number" value={form.idadi} onChange={e=>setForm(f=>({...f,idadi:e.target.value}))} placeholder="50"/>
        <Inp label="Kiwango cha Chini" type="number" value={form.min_stock} onChange={e=>setForm(f=>({...f,min_stock:e.target.value}))} placeholder="5"/>
        <div>
          <label style={{fontSize:11,fontWeight:700,color:"var(--gray-500)",display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>Kipimo</label>
          <select value={form.unit} onChange={e=>setForm(f=>({...f,unit:e.target.value}))}
            style={{width:"100%",padding:"12px 14px",border:"2px solid var(--gray-200)",borderRadius:"var(--r2)",fontSize:14,outline:"none",marginBottom:14}}>
            {["pcs","kg","lita","mfuko","chupa","sanduku","pakiti","mkate"].map(u=><option key={u}>{u}</option>)}
          </select>
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:700,color:"var(--gray-500)",display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>Kundi</label>
          {form.category==="__new__"
            ? <div style={{display:"flex",gap:6,marginBottom:14}}>
                <input autoFocus value={newCat} onChange={e=>setNewCat(e.target.value)}
                  onKeyDown={async e=>{if(e.key==="Enter"&&newCat.trim()){
                    const r=await api.products.categories.create(newCat.trim()).catch(()=>null);
                    if(r){setCats(p=>[...p,r]);setForm(f=>({...f,category:r.name}));}
                    else{setForm(f=>({...f,category:newCat.trim()}));}
                    setNewCat("");
                  }}}
                  placeholder="Jina la kundi jipya..."
                  style={{flex:1,padding:"10px 14px",border:"2px solid var(--teal)",borderRadius:"var(--r2)",fontSize:14,outline:"none"}}/>
                <button onClick={async()=>{
                  if(!newCat.trim()){setForm(f=>({...f,category:"Nyingine"}));return;}
                  const r=await api.products.categories.create(newCat.trim()).catch(()=>null);
                  if(r){setCats(p=>[...p,r]);setForm(f=>({...f,category:r.name}));}
                  else{setForm(f=>({...f,category:newCat.trim()}));}
                  setNewCat("");
                }} style={{padding:"10px 14px",background:"var(--teal)",color:"white",border:"none",borderRadius:"var(--r2)",cursor:"pointer",fontWeight:700,fontSize:13}}>Hifadhi</button>
                <button onClick={()=>setForm(f=>({...f,category:"Nyingine"}))}
                  style={{padding:"10px",background:"var(--gray-100)",border:"none",borderRadius:"var(--r2)",cursor:"pointer",color:"var(--gray-500)"}}>✕</button>
              </div>
            : <select value={form.category} onChange={e=>{
                if(e.target.value==="__new__"){setForm(f=>({...f,category:"__new__"}));return;}
                setForm(f=>({...f,category:e.target.value}));
              }} style={{width:"100%",padding:"12px 14px",border:"2px solid var(--gray-200)",borderRadius:"var(--r2)",fontSize:14,outline:"none",marginBottom:14}}>
                {[...cats.map(c=>c.name),...new Set(prods.map(p=>p.category||p.cat||"").filter(Boolean))]
                  .filter((v,i,a)=>v&&v!=="Nyingine"&&a.indexOf(v)===i)
                  .map(k=><option key={k} value={k}>{k}</option>)}
                <option value="Nyingine">Nyingine</option>
                <option value="__new__">+ Ongeza Kundi Jipya...</option>
              </select>
          }
        </div>
      </div>
      <Btn v="primary" sz="lg" full onClick={addProduct} disabled={loading}>
        {loading?"Inasalimisha...":"Hifadhi Bidhaa"}
      </Btn>
    </Modal>}


    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
      <div style={{fontSize:18,fontWeight:900}}>Bidhaa</div>
      <div style={{display:"flex",gap:8}}>
        <Btn v="secondary" sz="sm" onClick={onScan}>📷 Scan</Btn>
        <Btn v="secondary" sz="sm" onClick={()=>setShowCsvUpload(true)}>📥 CSV</Btn>
        <Btn v="primary" sz="sm" onClick={()=>setShowAdd(true)}>+ Ongeza</Btn>
      </div>
    </div>

    <div className="grid4" style={{marginBottom:12}}>
      {[{l:"Bidhaa Zote",v:prods.length,c:"var(--teal)"},
        {l:"Imeisha",v:prods.filter(p=>(p.stock||p.idadi||0)===0).length,c:"var(--red)"},
        {l:"Zinakwisha",v:prods.filter(p=>{const s=p.stock||p.idadi||0;const m=p.min_stock||5;return s>0&&s<=m;}).length,c:"var(--amber)"},
        {l:"Zero-Lock",v:zeroLock?"ON":"OFF",c:zeroLock?"var(--green)":"var(--red)"}
      ].map((s,i)=><Card key={i} style={{padding:"12px",textAlign:"center"}}>
        <div style={{fontSize:20,fontWeight:900,color:s.c}}>{s.v}</div>
        <div style={{fontSize:9,color:"var(--gray-400)",marginTop:3,fontWeight:700,textTransform:"uppercase",letterSpacing:.5}}>{s.l}</div>
      </Card>)}
    </div>

    <div style={{padding:"11px 14px",borderRadius:"var(--r2)",marginBottom:12,
      background:zeroLock?"var(--green-l)":"var(--red-l)",
      border:"1px solid "+(zeroLock?"#a7f3d0":"#fecaca"),
      display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <div style={{fontSize:12,fontWeight:700,color:zeroLock?"var(--green)":"var(--red)"}}>
        Zero-Lock: {zeroLock?"WASHA":"ZIMA"}
      </div>
      <Btn v={zeroLock?"danger":"success"} sz="sm" onClick={()=>setZeroLock(b=>!b)}>
        {zeroLock?"Zima":"Washa"}
      </Btn>
    </div>

    <div style={{position:"relative",marginBottom:12}}>
      <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:"var(--gray-400)",fontSize:16}}>⌕</span>
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Tafuta bidhaa..."
        style={{width:"100%",padding:"12px 14px 12px 34px",border:"2px solid var(--gray-200)",
          borderRadius:"var(--r2)",fontSize:14,outline:"none",background:"white"}}
        onFocus={e=>e.target.style.borderColor="var(--teal)"}
        onBlur={e=>e.target.style.borderColor="var(--gray-200)"}/>
    </div>

    {isOwner&&selected.length>0&&<div style={{display:"flex",gap:8,alignItems:"center",
      padding:"10px 14px",background:"var(--red-l)",borderRadius:"var(--r2)",
      border:"1px solid #fecaca",marginBottom:8}}>
      <span style={{fontSize:12,fontWeight:700,color:"var(--red)",flex:1}}>
        {selected.length} bidhaa zimechaguliwa
      </span>
      <Btn v="danger" sz="sm" onClick={deleteSelected}>Futa Zote</Btn>
      <Btn v="secondary" sz="sm" onClick={()=>setSelected([])}>Ghairi</Btn>
    </div>}
    {isOwner&&filtered.length>0&&<div style={{display:"flex",justifyContent:"flex-end",marginBottom:4}}>
      <button onClick={()=>setSelected(s=>s.length===filtered.length?[]:filtered.map(x=>x.id))}
        style={{fontSize:11,color:"var(--teal)",background:"none",border:"none",cursor:"pointer",fontWeight:700}}>
        {selected.length===filtered.length?"Ghairi Chaguo Zote":"Chagua Zote"}
      </button>
    </div>}
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {filtered.map((p,i)=>{
        const stock=p.stock||p.idadi||0;
        const price=p.price||p.bei_uuzaji||0;
        const name=p.name||p.jina||"";
        const sc=stock===0?"var(--red)":stock<=5?"var(--amber)":"var(--green)";
        return <Card key={p.id} style={{padding:"12px 14px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:700,marginBottom:3}}>{name}</div>
              <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                <span style={{fontSize:12,color:"var(--teal)",fontWeight:800}}>{fmt(price)}</span>
                {p.sku&&<span style={{fontSize:10,color:"var(--gray-400)"}}>{p.sku}</span>}
                <Badge color={stock===0?"red":stock<=5?"amber":"green"}>{stock===0?"ZIMEISHA":stock<=5?"CHINI":"SAWA"}</Badge>
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
              {editId===p.id
                ?<div style={{display:"flex",flexDirection:"column",gap:6,minWidth:200}}>
                    <div style={{display:"flex",flexDirection:"column",gap:6}}>
                      <div>
                        <div style={{fontSize:10,fontWeight:700,color:"var(--gray-500)",marginBottom:3,textTransform:"uppercase",letterSpacing:.6}}>Jina la Bidhaa</div>
                        <input type="text" value={editForm.jina}
                          onChange={e=>setEditForm(f=>({...f,jina:e.target.value}))}
                          placeholder="Jina la bidhaa"
                          style={{width:"100%",padding:"7px 10px",border:"2px solid var(--teal)",
                            borderRadius:6,fontSize:13,outline:"none",color:"var(--gray-800)",fontWeight:600}}/>
                      </div>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                        <div>
                          <div style={{fontSize:10,fontWeight:700,color:"var(--gray-500)",marginBottom:3,textTransform:"uppercase",letterSpacing:.6}}>Bei Uuzaji</div>
                          <input type="number" value={editForm.price}
                            onChange={e=>setEditForm(f=>({...f,price:e.target.value}))}
                            placeholder="Bei" min="0"
                            style={{width:"100%",padding:"7px 8px",border:"2px solid var(--teal)",
                              borderRadius:6,fontSize:13,outline:"none",color:"var(--teal)",fontWeight:700}}/>
                        </div>
                        <div>
                          <div style={{fontSize:10,fontWeight:700,color:"var(--gray-500)",marginBottom:3,textTransform:"uppercase",letterSpacing:.6}}>Zilizobaki</div>
                          <input type="number" value={editForm.stock}
                            onChange={e=>setEditForm(f=>({...f,stock:e.target.value}))}
                            placeholder="Zilizobaki" min="0"
                            style={{width:"100%",padding:"7px 8px",border:"2px solid var(--teal)",
                              borderRadius:6,fontSize:13,outline:"none",color:"var(--teal)",fontWeight:700}}/>
                        </div>
                        <div>
                          <div style={{fontSize:10,fontWeight:700,color:"var(--amber)",marginBottom:3,textTransform:"uppercase",letterSpacing:.6}}>Kiwango cha Chini</div>
                          <input type="number" value={editForm.min_stock}
                            onChange={e=>setEditForm(f=>({...f,min_stock:e.target.value}))}
                            placeholder="Kiwango" min="0"
                            style={{width:"100%",padding:"7px 8px",border:"2px solid var(--amber)",
                              borderRadius:6,fontSize:13,outline:"none",color:"var(--amber)",fontWeight:700}}/>
                        </div>
                        <div>
                          <div style={{fontSize:10,fontWeight:700,color:"var(--gray-400)",marginBottom:3,textTransform:"uppercase",letterSpacing:.6}}>Bei Kununua</div>
                          <input type="number" value={editForm.bei_ununuzi}
                            onChange={e=>setEditForm(f=>({...f,bei_ununuzi:e.target.value}))}
                            placeholder="0" min="0"
                            style={{width:"100%",padding:"7px 8px",border:"2px solid var(--gray-200)",
                              borderRadius:6,fontSize:13,outline:"none",color:"var(--gray-600)",fontWeight:700}}/>
                        </div>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:5}}>
                      <button onClick={async()=>{
                        const sv=parseInt(document.getElementById("s"+p.id)?.value);
                        const pv=parseFloat(document.getElementById("pr"+p.id)?.value);
                        const mv=parseInt(document.getElementById("m"+p.id)?.value);
                        try{
                          const nv=editForm.jina||name;
                          const prv=parseFloat(editForm.price)||price;
                          const sv2=parseInt(editForm.stock);
                          const mv2=parseInt(editForm.min_stock)||5;
                          await apiFetch("/bidhaa/"+p.id,{method:"PUT",body:JSON.stringify({
                            jina:nv, bei_uuzaji:prv, idadi:isNaN(sv2)?stock:sv2,
                            kiwango_chini:mv2, bei_ununuzi:parseFloat(editForm.bei_ununuzi)||p.bei_ununuzi||0, unit:p.unit||"pcs"
                          })});
                          setProds(prev=>prev.map(x=>x.id===p.id?{...x,
                            name:nv,jina:nv,price:prv,bei_uuzaji:prv,
                            stock:isNaN(sv2)?x.stock:sv2,idadi:isNaN(sv2)?x.idadi:sv2,
                            min_stock:mv2}:x));
                          setEditId(null);onToast("Imesasishwa","success");
                        }catch(e){onToast(e.message,"error");}
                      }} style={{flex:1,background:"var(--green-l)",border:"1px solid #a7f3d0",
                        color:"var(--green)",borderRadius:6,padding:"6px 10px",
                        cursor:"pointer",fontWeight:700,fontSize:12}}>Hifadhi</button>
                      <button onClick={()=>setEditId(null)}
                        style={{background:"var(--gray-100)",border:"none",borderRadius:6,
                          padding:"6px 8px",cursor:"pointer",color:"var(--gray-500)"}}>✕</button>
                    </div>
                  </div>
                :<div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:18,fontWeight:900,color:sc,minWidth:32}}>{stock}</div>
                    {stock<=(p.min_stock||5)&&stock>0&&<div style={{fontSize:9,color:"var(--amber)",fontWeight:700}}>MIN:{p.min_stock||5}</div>}
                  </div>
                  {isOwner&&<input type="checkbox" checked={selected.includes(p.id)}
                    onChange={()=>toggleSel(p.id)}
                    style={{width:16,height:16,accentColor:"var(--teal)",cursor:"pointer"}}/>}
                  {isOwner&&<Btn v="secondary" sz="sm" onClick={()=>{setEditId(p.id);setEditForm({jina:name,price:String(price),stock:String(stock),min_stock:String(p.min_stock||5),bei_ununuzi:String(p.bei_ununuzi||0)});}}>✏️</Btn>}
                  {isOwner&&<Btn v="danger" sz="sm" onClick={()=>deleteSingle(p.id)}>🗑</Btn>}
                </div>}
            </div>
          </div>
        </Card>;
      })}
    </div>
  </div>;
}

/* ─── TAB: WATEJA ─────────────────────────────────────────────────────────── */
function TabWateja({onToast}){
  const [debts,setDebts]=useState([]);
  const [view,setView]=useState("madeni");
  const [showForm,setShowForm]=useState(false);
  const [loading,setLoading]=useState(true);
  const [debtForm,setDebtForm]=useState({type:"receivable",name:"",phone:"",amount:"",note:""});
  const [filter,setFilter]=useState("all");

  useEffect(()=>{
    api.debts.list().then(d=>{setDebts(d);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  const totalR=debts.filter(d=>(d.type==="receivable"||d.aina==="mdai")&&!d.paid&&d.status!=="paid").reduce((s,d)=>s+d.amount,0);
  const totalP=debts.filter(d=>(d.type==="payable"||d.aina==="deni")&&!d.paid&&d.status!=="paid").reduce((s,d)=>s+d.amount,0);

  const shown=debts.filter(d=>{
    if(filter==="unpaid")return!d.paid&&d.status!=="paid";
    return true;
  });

  async function addDebt(){
    if(!debtForm.name||!debtForm.amount){onToast("Jaza taarifa zinazohitajika","error");return;}
    try{
      const d=await api.debts.create({
        jina_mdaiwa:debtForm.name,
        namba_simu:debtForm.phone,
        kiasi:parseFloat(debtForm.amount),
        maelezo:debtForm.note,
        aina:debtForm.type,
        type:debtForm.type,
      });
      setDebts(p=>[d,...p]);
      setDebtForm({type:"receivable",name:"",phone:"",amount:"",note:""});
      setShowForm(false);onToast("Deni limeandikwa","success");
    }catch(e){onToast(e.message,"error");}
  }

  async function markPaid(id){
    try{
      await api.debts.pay(id);
      setDebts(p=>p.map(d=>d.id===id?{...d,paid:!d.paid,status:d.paid?"pending":"paid"}:d));
      onToast("Hali imebadilishwa","info");
    }catch(e){onToast(e.message,"error");}
  }

  async function removeDebt(id){
    try{
      await api.debts.remove(id);
      setDebts(p=>p.filter(d=>d.id!==id));
      onToast("Imefutwa","warn");
    }catch(e){onToast(e.message,"error");}
  }

  return <div>
    {showForm&&<Modal title="Ongeza Deni" onClose={()=>setShowForm(false)}>
      <div style={{display:"flex",gap:10,marginBottom:14}}>
        {[["receivable","Anakudai"],["payable","Unamudai"]].map(([val,lbl])=>(
          <button key={val} onClick={()=>setDebtForm(f=>({...f,type:val}))}
            style={{flex:1,padding:"10px",borderRadius:"var(--r2)",cursor:"pointer",fontWeight:700,
              fontSize:13,fontFamily:"var(--font)",
              border:"2px solid "+(debtForm.type===val?"var(--teal)":"var(--gray-200)"),
              background:debtForm.type===val?"var(--teal-l)":"white",
              color:debtForm.type===val?"var(--teal)":"var(--gray-500)"}}>{lbl}</button>
        ))}
      </div>
      <Inp label="Jina *" value={debtForm.name} onChange={e=>setDebtForm(f=>({...f,name:e.target.value}))} placeholder="Jina la mtu" required/>
      <Inp label="Simu" value={debtForm.phone} onChange={e=>setDebtForm(f=>({...f,phone:e.target.value}))} placeholder="0712 345 678"/>
      <Inp label="Kiasi (TZS) *" type="number" value={debtForm.amount} onChange={e=>setDebtForm(f=>({...f,amount:e.target.value}))} placeholder="50000" required/>
      <Inp label="Maelezo" value={debtForm.note} onChange={e=>setDebtForm(f=>({...f,note:e.target.value}))} placeholder="Bidhaa gani / sababu"/>
      <Btn v="primary" sz="lg" full onClick={addDebt}>Hifadhi Deni</Btn>
    </Modal>}

    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
      <div style={{fontSize:18,fontWeight:900}}>Wateja & Madeni</div>
      <Btn v="primary" sz="sm" onClick={()=>setShowForm(true)}>+ Deni</Btn>
    </div>

    <div className="grid3" style={{marginBottom:14}}>
      <Card style={{background:"var(--green-l)",border:"1px solid #a7f3d0",padding:"13px 14px"}}>
        <div style={{fontSize:10,color:"var(--green)",fontWeight:800,textTransform:"uppercase",letterSpacing:.8,marginBottom:4}}>Wanakudai</div>
        <div style={{fontSize:18,fontWeight:900,color:"var(--green)"}}>{fmt(totalR)}</div>
      </Card>
      <Card style={{background:"var(--red-l)",border:"1px solid #fecaca",padding:"13px 14px"}}>
        <div style={{fontSize:10,color:"var(--red)",fontWeight:800,textTransform:"uppercase",letterSpacing:.8,marginBottom:4}}>Unawadai</div>
        <div style={{fontSize:18,fontWeight:900,color:"var(--red)"}}>{fmt(totalP)}</div>
      </Card>
      <Card style={{background:"var(--teal-l)",border:"1px solid var(--teal-m)",padding:"13px 14px"}}>
        <div style={{fontSize:10,color:"var(--teal)",fontWeight:800,textTransform:"uppercase",letterSpacing:.8,marginBottom:4}}>Halisi</div>
        <div style={{fontSize:18,fontWeight:900,color:"var(--teal)"}}>{fmt(Math.abs(totalR-totalP))}</div>
      </Card>
    </div>

    <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
      {[["all","Yote"],["unpaid","Hazijalipwa"]].map(([val,lbl])=>(
        <button key={val} onClick={()=>setFilter(val)} style={{padding:"7px 14px",borderRadius:20,cursor:"pointer",
          fontSize:12,fontWeight:700,fontFamily:"var(--font)",
          border:"2px solid "+(filter===val?"var(--teal)":"var(--gray-200)"),
          background:filter===val?"var(--teal)":"white",color:filter===val?"white":"var(--gray-600)"}}>{lbl}</button>
      ))}
    </div>

    {loading?<Spinner/>:<div style={{display:"flex",flexDirection:"column",gap:10}}>
      {shown.map(d=>{
        const name=d.name||d.jina_mdaiwa||"";
        const phone=d.phone||d.namba_simu||"";
        const amount=d.amount||d.kiasi||0;
        const note=d.note||d.maelezo||"";
        const isPaid=d.paid||d.status==="paid"||d.status==="partial";
        const isReceivable=d.aina==="receivable"||d.type==="receivable"||(!d.type&&!d.aina);
        return <Card key={d.id} style={{opacity:isPaid?.6:1,
          borderLeft:"3px solid "+(isReceivable?"var(--green)":"var(--red)")}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",gap:6,marginBottom:6,flexWrap:"wrap"}}>
                <Badge color={isReceivable?"green":"red"}>{isReceivable?"ANAKUDAI":"UNAMUDAI"}</Badge>
                {isPaid&&<Badge color="gray">IMELIPWA</Badge>}
              </div>
              <div style={{fontSize:14,fontWeight:800}}>{name}</div>
              {phone&&<div style={{fontSize:11,color:"var(--gray-400)",marginTop:2}}>{phone}</div>}
              {note&&<div style={{fontSize:11,color:"var(--gray-500)",fontStyle:"italic",marginTop:2}}>"{note}"</div>}
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:6,alignItems:"flex-end",flexShrink:0}}>
              <div style={{fontSize:16,fontWeight:900,color:isReceivable?"var(--green)":"var(--red)"}}>{fmt(amount)}</div>
              <div style={{display:"flex",gap:6}}>
                {phone&&<Btn v="wa" sz="sm" onClick={()=>{
                  const ph=phone.replace(/\D/g,"").replace(/^0/,"");
                  const msg="Habari "+name+",\nTukikumbusha deni la *"+fmt(amount)+"*"+(note?" — "+note:"")+".\nAsante — HesabuSmart\nhesabusmart.co.tz";
                  window.open("https://wa.me/255"+ph+"?text="+encodeURIComponent(msg),"_blank");
                }}>WA</Btn>}
                <Btn v={isPaid?"secondary":"success"} sz="sm" onClick={()=>markPaid(d.id)}>
                  {isPaid?"Rudisha":"Lipa"}
                </Btn>
                <Btn v="danger" sz="sm" onClick={()=>removeDebt(d.id)}>✕</Btn>
              </div>
            </div>
          </div>
        </Card>;
      })}
      {shown.length===0&&<div style={{textAlign:"center",padding:32,color:"var(--gray-300)"}}>
        <div style={{fontSize:32}}>📒</div>
        <div style={{fontSize:13,marginTop:8}}>Hakuna madeni</div>
      </div>}
    </div>}
  </div>;
}

/* ─── TAB: MATUMIZI ───────────────────────────────────────────────────────── */
function TabMatumizi({onToast}){
  const [expenses,setExpenses]=useState([]);
  const [showForm,setShowForm]=useState(false);
  const [loading,setLoading]=useState(true);
  const [form,setForm]=useState({category:"Kodi",description:"",amount:""});
  const CATS=["Kodi","Umeme","Maji","Mshahara","Usafiri","Usambazaji","Chakula","Matengenezo","Ununuzi wa Bidhaa","Nyingine"];

  useEffect(()=>{
    api.expenses.list().then(e=>{setExpenses(e);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  const total=expenses.reduce((s,e)=>s+(e.amount||e.kiasi||0),0);

  async function addExp(){
    if(!form.description||!form.amount){onToast("Jaza maelezo na kiasi","error");return;}
    try{
      const e=await api.expenses.create({
        category:form.category,
        maelezo:form.description,
        description:form.description,
        kiasi:parseFloat(form.amount),
        amount:parseFloat(form.amount),
      });
      setExpenses(p=>[e,...p]);
      setForm({category:"Kodi",description:"",amount:""});
      setShowForm(false);onToast("Matumizi yameandikwa","success");
    }catch(e){onToast(e.message,"error");}
  }

  async function removeExp(id){
    try{
      await api.expenses.remove(id);
      setExpenses(p=>p.filter(e=>e.id!==id));
      onToast("Imefutwa","warn");
    }catch(e){onToast(e.message,"error");}
  }

  return <div>
    {showForm&&<Modal title="Ongeza Matumizi" onClose={()=>setShowForm(false)}>
      <div>
        <label style={{fontSize:11,fontWeight:700,color:"var(--gray-500)",display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>Kategoria</label>
        <select value={CATS.includes(form.category)?form.category:"Nyingine"} 
          onChange={e=>setForm(f=>({...f,category:e.target.value}))}
          style={{width:"100%",padding:"12px 14px",border:"2px solid var(--gray-200)",borderRadius:"var(--r2)",fontSize:14,outline:"none",marginBottom:8}}>
          {CATS.map(c=><option key={c}>{c}</option>)}
        </select>
        {(!CATS.includes(form.category)||form.category==="Nyingine")&&
          <input value={form.category==="Nyingine"?"":form.category}
            onChange={e=>setForm(f=>({...f,category:e.target.value||"Nyingine"}))}
            placeholder="Andika kategoria yako (mfano: Chakula cha Mchana)..."
            style={{width:"100%",padding:"10px 14px",border:"2px solid var(--teal)",borderRadius:"var(--r2)",
              fontSize:13,outline:"none",marginBottom:14,boxSizing:"border-box"}}/>
        }
      </div>
      <Inp label="Maelezo *" value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} placeholder="Kodi ya Machi 2026" required/>
      <Inp label="Kiasi (TZS) *" type="number" value={form.amount} onChange={e=>setForm(f=>({...f,amount:e.target.value}))} placeholder="150000" required/>
      <Btn v="primary" sz="lg" full onClick={addExp}>Hifadhi Matumizi</Btn>
    </Modal>}

    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
      <div style={{fontSize:18,fontWeight:900}}>Matumizi</div>
      <Btn v="primary" sz="sm" onClick={()=>setShowForm(true)}>+ Ongeza</Btn>
    </div>

    <Card style={{background:"linear-gradient(135deg,var(--red),#dc2626)",marginBottom:14}}>
      <div style={{fontSize:10,fontWeight:700,color:"rgba(255,255,255,.7)",textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Jumla ya Matumizi</div>
      <div style={{fontSize:28,fontWeight:900,color:"white"}}>{fmt(total)}</div>
      <div style={{fontSize:11,color:"rgba(255,255,255,.6)",marginTop:4}}>{expenses.length} rekodi</div>
    </Card>

    {loading?<Spinner/>:<div style={{display:"flex",flexDirection:"column",gap:8}}>
      {expenses.map((e,i)=>{
        const desc=e.description||e.maelezo||"—";
        const cat=e.category||e.kategoria||"Nyingine";
        const amt=e.amount||e.kiasi||0;
        return <Card key={e.id||i} style={{padding:"12px 14px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <div style={{fontSize:13,fontWeight:600}}>{desc}</div>
              <div style={{display:"flex",gap:6,marginTop:4,alignItems:"center"}}>
                <Badge color="gray">{cat}</Badge>
                <span style={{fontSize:10,color:"var(--gray-400)"}}>{e.created_at?new Date(e.created_at).toLocaleDateString():""}</span>
              </div>
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
              <span style={{fontSize:14,fontWeight:800,color:"var(--red)"}}>{fmt(amt)}</span>
              <button onClick={()=>removeExp(e.id)}
                style={{background:"var(--red-l)",border:"none",borderRadius:6,padding:"5px 9px",
                  cursor:"pointer",color:"var(--red)",fontSize:12,fontWeight:700}}>✕</button>
            </div>
          </div>
        </Card>;
      })}
    </div>}
  </div>;
}

/* ─── TAB: NUKUU ─────────────────────────────────────────────────────────── */
function TabNukuu({prods,zeroLock,onToast,onScan,onPrint}){
  const [items,setItems]=useState([]);
  const [cName,setCName]=useState("");
  const [cPhone,setCPhone]=useState("");
  const [copied,setCopied]=useState(false);
  const total=items.reduce((s,i)=>s+i.price*i.qty,0);

  function addItem(p){
    const stock=p.stock||p.idadi||0;
    const price=p.price||p.bei_uuzaji||0;
    const name=p.name||p.jina||"";
    if(zeroLock&&stock===0){onToast("Hakuna stoki: "+name,"error");return;}
    setItems(prev=>{
      const ex=prev.find(i=>i.id===p.id);
      if(ex){const nq=ex.qty+1;if(zeroLock&&nq>stock){onToast("Zilizobaki: "+stock+" tu","warn");return prev;}
        return prev.map(i=>i.id===p.id?{...i,qty:nq}:i);}
      return [...prev,{id:p.id,name,price,unit:p.unit||"pcs",qty:1,stock}];
    });
  }

  function updQty(id,n){
    if(isNaN(n)||n<1)return;
    const it=items.find(x=>x.id===id);
    if(zeroLock&&it&&n>it.stock){onToast("Zilizobaki: "+it.stock+" tu","warn");return;}
    setItems(prev=>prev.map(i=>i.id===id?{...i,qty:n}:i));
  }

  function genMsg(){
    let m="*HESABUSMART — NUKUU YA BEI*\n"+"━".repeat(22)+"\n";
    if(cName) m+="Mteja: *"+cName+"*\n";
    m+="Tarehe: "+dateStr()+"\n"+"━".repeat(22)+"\n\n";
    items.forEach((it,i)=>{m+=(i+1)+". "+it.name+"\n   "+it.qty+" x "+fmt(it.price)+" = *"+fmt(it.qty*it.price)+"*\n\n";});
    m+="━".repeat(22)+"\n*JUMLA: "+fmt(total)+"*\n"+"━".repeat(22)+"\n_hesabusmart.co.tz_";
    return m;
  }

  return <div>
    <div style={{fontSize:18,fontWeight:900,marginBottom:16}}>Quick Quote</div>
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <Card>
        <STitle>Taarifa za Mteja</STitle>
        <div className="grid2" style={{gap:"0 14px"}}>
          <Inp label="Jina" value={cName} onChange={e=>setCName(e.target.value)} placeholder="Mama Fatuma"/>
          <Inp label="Simu" value={cPhone} onChange={e=>setCPhone(e.target.value)} placeholder="0712 345 678"/>
        </div>
      </Card>
      <Card>
        <STitle>Ongeza Bidhaa</STitle>
        <ProdSearch prods={prods} onAdd={addItem} zeroLock={zeroLock} onScan={onScan}/>
      </Card>
      <Card>
        <STitle>Orodha ({items.length})</STitle>
        <CartList items={items} onUpdQty={updQty} onRemove={id=>setItems(p=>p.filter(x=>x.id!==id))}/>
      </Card>

      {/* WhatsApp preview */}
      {items.length>0&&<Card>
        <STitle>Ujumbe wa WhatsApp</STitle>
        <div style={{background:"#e5ddd5",borderRadius:"var(--r)",marginBottom:14,overflow:"hidden"}}>
          <div style={{background:"#075e54",padding:"10px 13px",display:"flex",alignItems:"center",gap:8}}>
            <div style={{width:26,height:26,borderRadius:"50%",background:"#25D366",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13}}>💬</div>
            <div style={{fontSize:11,color:"white",fontWeight:700}}>{cPhone?"+255 "+cPhone:"WhatsApp"}</div>
          </div>
          <div style={{padding:12}}>
            <div style={{background:"white",borderRadius:"0 10px 10px 10px",padding:"10px 12px",
              display:"inline-block",maxWidth:"95%",boxShadow:"0 1px 3px rgba(0,0,0,.1)"}}>
              <pre style={{fontFamily:"var(--font)",fontSize:11,lineHeight:1.7,color:"var(--gray-800)",
                whiteSpace:"pre-wrap",wordBreak:"break-word",margin:0}}>{genMsg()}</pre>
              <div style={{fontSize:9,color:"var(--gray-400)",textAlign:"right",marginTop:4}}>{timeStr()} ✓✓</div>
            </div>
          </div>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:9}}>
          <Btn v="wa" sz="lg" full onClick={()=>{
            const ph=cPhone.replace(/\D/g,"").replace(/^0/,"");
            window.open(ph?"https://wa.me/255"+ph+"?text="+encodeURIComponent(genMsg())
              :"https://wa.me/?text="+encodeURIComponent(genMsg()),"_blank");
          }}>Tuma WhatsApp</Btn>
          <div className="grid2" style={{gap:9}}>
            <Btn v={copied?"success":"secondary"} full onClick={()=>{
              navigator.clipboard.writeText(genMsg());setCopied(true);
              onToast("Ujumbe umenakilishwa","success");setTimeout(()=>setCopied(false),2500);
            }}>{copied?"Nakili!":"Nakili"}</Btn>
            <Btn v="outline" full onClick={()=>onPrint({items,total,customer:cName})}>Chapisha</Btn>
          </div>
          <Btn v="amber" full disabled={items.length===0} onClick={async()=>{
            try{
              await api.orders.create({
                jina_mteja:cName||null,
                simu_mteja:cPhone||null,
                jumla:total,
                bidhaa:items.map(i=>({id:i.id,name:i.name,qty:i.qty,price:i.price,jina:i.name,idadi:i.qty,bei:i.price})),
                maelezo:items.map(i=>i.name+" x"+i.qty).join(", "),
              });
              onToast("Oda imehifadhiwa!","success");
              setItems([]);setCName("");setCPhone("");
            }catch(e){onToast(e.message,"error");}
          }} style={{background:"var(--amber)",color:"white",boxShadow:"0 3px 10px rgba(245,158,11,.3)"}}>
            📋 Hifadhi kama Oda
          </Btn>
          <Btn v="danger" full onClick={()=>{setItems([]);setCName("");setCPhone("");}}>Futa Nukuu</Btn>
        </div>
      </Card>}
    </div>
  </div>;
}


/* ─── TAB: TIMU (Team management) ───────────────────────────────────────── */
function TabTimu({onToast,shop}){
  const [users,setUsers]=useState([]);
  const [loading,setLoading]=useState(true);
  const [showForm,setShowForm]=useState(false);
  const [form,setForm]=useState({jina:"",simu:"",email:"",password:"",role:"muuzaji"});

  useEffect(()=>{
    api.users.list().then(u=>{setUsers(u);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  async function addUser(){
    if(!form.jina||!form.simu||!form.password){onToast("Jaza jina, simu, na nywila","error");return;}
    if(form.password.length<6){onToast("Nywila iwe na herufi 6+","error");return;}
    try{
      const u=await api.users.create(form);
      setUsers(p=>[...p,u]);
      setForm({jina:"",simu:"",email:"",password:"",role:"muuzaji"});
      setShowForm(false);
      onToast("Mtumiaji ameongezwa","success");
    }catch(e){onToast(e.message,"error");}
  }

  async function toggleUser(id){
    try{
      const u=await api.users.toggle(id);
      setUsers(p=>p.map(x=>x.id===id?u:x));
      onToast("Hali imebadilishwa","info");
    }catch(e){onToast(e.message,"error");}
  }

  async function removeUser(id){
    try{
      await api.users.remove(id);
      setUsers(p=>p.filter(x=>x.id!==id));
      onToast("Mtumiaji amefutwa","warn");
    }catch(e){onToast(e.message,"error");}
  }

  return <div>
    {showForm&&<Modal title="Ongeza Mtumiaji" onClose={()=>setShowForm(false)}>
      <Inp label="Jina Kamili *" value={form.jina} onChange={e=>setForm(f=>({...f,jina:e.target.value}))} placeholder="Amina Hassan" required/>
      <Inp label="Nambari ya Simu *" type="tel" value={form.simu} onChange={e=>setForm(f=>({...f,simu:e.target.value}))} placeholder="0712 345 678" required/>
      <Inp label="Barua Pepe" type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="amina@duka.co.tz"/>
      <Inp label="Nywila *" type="password" value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder="Herufi 6+" required/>
      <div style={{marginBottom:14}}>
        <label style={{fontSize:11,fontWeight:700,color:"var(--gray-500)",display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>Jukumu</label>
        <div style={{display:"flex",gap:10}}>
          {[["muuzaji","Muuzaji"],["admin","Admin"]].map(([val,lbl])=>(
            <button key={val} onClick={()=>setForm(f=>({...f,role:val}))}
              style={{flex:1,padding:"10px",borderRadius:"var(--r2)",cursor:"pointer",fontWeight:700,
                fontSize:13,fontFamily:"var(--font)",
                border:"2px solid "+(form.role===val?"var(--teal)":"var(--gray-200)"),
                background:form.role===val?"var(--teal-l)":"white",
                color:form.role===val?"var(--teal)":"var(--gray-500)"}}>{lbl}</button>
          ))}
        </div>
      </div>
      <div style={{background:"var(--teal-l)",border:"1px solid var(--teal-m)",borderRadius:"var(--r2)",
        padding:"11px 14px",marginBottom:14,fontSize:12,color:"var(--teal-d)"}}>
        <strong>Muuzaji</strong> — Anaona POS, Nukuu, Bidhaa tu. Haoni faida, matumizi, au ripoti.<br/>
        <strong>Admin</strong> — Anaona kila kitu isipokuwa usimamizi wa akaunti ya duka.
      </div>
      <Btn v="primary" sz="lg" full onClick={addUser}>Ongeza Mtumiaji</Btn>
    </Modal>}

    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
      <div style={{fontSize:18,fontWeight:900}}>Timu</div>
      <Btn v="primary" sz="sm" onClick={()=>setShowForm(true)}>+ Ongeza</Btn>
    </div>

    <Card style={{background:"var(--teal-l)",border:"1px solid var(--teal-m)",marginBottom:14,padding:"14px 16px"}}>
      <div style={{fontSize:12,fontWeight:800,color:"var(--teal-d)",marginBottom:4}}>Akaunti ya Mmiliki</div>
      <div style={{fontSize:14,fontWeight:700}}>{shop?.owner_name||shop?.name||"Mmiliki"}</div>
      <div style={{fontSize:11,color:"var(--teal-d)",marginTop:2}}>Ingia kwa barua pepe · Anaona kila kitu</div>
    </Card>

    {loading?<Spinner/>:users.length===0
      ?<div style={{textAlign:"center",padding:32,color:"var(--gray-300)"}}>
          <div style={{fontSize:32}}>👥</div>
          <div style={{fontSize:13,marginTop:8}}>Hakuna wafanyakazi bado</div>
          <div style={{fontSize:11,marginTop:4,color:"var(--gray-400)"}}>Ongeza muuzaji au admin</div>
        </div>
      :<div style={{display:"flex",flexDirection:"column",gap:10}}>
        {users.map(u=><Card key={u.id}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{display:"flex",gap:12,alignItems:"center"}}>
              <div style={{width:44,height:44,borderRadius:"50%",
                background:u.role==="admin"?"var(--teal-m)":"var(--gray-100)",
                display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>
                {u.role==="admin"?"🔑":"👤"}
              </div>
              <div>
                <div style={{fontSize:14,fontWeight:800}}>{u.jina}</div>
                <div style={{fontSize:11,color:"var(--gray-400)",marginTop:2}}>{u.simu}{u.email?" · "+u.email:""}</div>
                <div style={{display:"flex",gap:6,marginTop:4,alignItems:"center"}}>
                  <Badge color={u.role==="admin"?"teal":"blue"}>{u.role==="admin"?"ADMIN":"MUUZAJI"}</Badge>
                  <Badge color={u.active?"green":"red"}>{u.active?"AKTIVI":"AMEZIMWA"}</Badge>
                </div>
              </div>
            </div>
            <div style={{display:"flex",gap:6,flexDirection:"column",alignItems:"flex-end"}}>
              <Btn v={u.active?"amber":"success"} sz="sm" onClick={()=>toggleUser(u.id)}>
                {u.active?"Zima":"Washa"}
              </Btn>
              <Btn v="danger" sz="sm" onClick={()=>removeUser(u.id)}>Futa</Btn>
            </div>
          </div>
        </Card>)}
      </div>}
  </div>;
}

/* ─── TAB: RIPOTI ────────────────────────────────────────────────────────── */
function TabRipoti({prods,onToast}){
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [njia,setNjia]=useState([]);
  const [kipindi,setKipindi]=useState('mwezi');
  const [muhtasari,setMuhtasari]=useState(null);

  useEffect(()=>{
    setLoading(true);
    api.dashboard().then(setData).catch(()=>setData(null));
    apiFetch('/ripoti/muhtasari?kipindi='+kipindi).then(setMuhtasari).catch(()=>setMuhtasari(null)).finally(()=>setLoading(false));
    apiFetch('/ripoti/njia-malipo?kipindi='+kipindi).then(rows=>{
      // Merge mpesa variants
      const merged={};
      rows.forEach(r=>{
        const key=r.njia_malipo.toLowerCase().replace("-","");
        if(!merged[key]) merged[key]={njia:r.njia_malipo,jumla:0,idadi:0};
        merged[key].jumla+=parseFloat(r.jumla);
        merged[key].idadi+=parseInt(r.idadi);
      });
      setNjia(Object.values(merged));
    }).catch(()=>{});
  },[kipindi]);

  if(loading) return <Spinner/>;
  const d=data||{month_sales:0,month_expenses:0,net_profit:0,out_of_stock:0};
  const m=muhtasari||{mapato:0,matumizi:0,faida:0};
  const mapato=parseFloat(m.mapato||0);
  const matumizi=parseFloat(m.matumizi||0);
  const faida=parseFloat(m.faida||0);
  const kipindiLabel={leo:'Leo',wiki:'Wiki Hii',mwezi:'Mwezi Huu'}[kipindi]||'Mwezi Huu';

  return <div>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
      <Btn v="secondary" sz="sm" onClick={()=>{
        const w=window.open("","_blank");
        w.document.write("<html><head><title>Ripoti HesabuSmart</title><style>body{font-family:sans-serif;padding:24px;max-width:600px;margin:0 auto}h1{color:#0d9488}table{width:100%;border-collapse:collapse;margin:16px 0}td,th{padding:10px 12px;border:1px solid #ddd}th{background:#f0fdfa}.btn{display:block;width:100%;padding:14px;background:#0d9488;color:white;border:none;border-radius:8px;font-size:16px;font-weight:700;margin-top:20px;cursor:pointer}@media print{.btn{display:none}}</style></head><body><h1>Ripoti ya HesabuSmart ERP</h1><p>"+dateStr()+" — "+kipindiLabel+"</p><table><tr><th>Kipengele</th><th>Kiasi</th></tr><tr><td>Mapato</td><td>"+fmt(mapato)+"</td></tr><tr><td>Matumizi</td><td>"+fmt(matumizi)+"</td></tr><tr><td><b>Faida</b></td><td><b>"+fmt(faida)+"</b></td></tr></table><button class=\'btn\' onclick=\'window.close()\'>← Rudi Nyuma</button><script>window.onload=function(){window.print()}<\/script></body></html>");
        w.document.close();
      }}>🖨️ Chapisha</Btn>
    </div>
    <div style={{display:"flex",gap:4,marginBottom:16,background:"var(--gray-100)",borderRadius:"var(--r2)",padding:3}}>
      {[["leo","Leo"],["wiki","Wiki"],["mwezi","Mwezi"]].map(([v,l])=>(
        <button key={v} onClick={()=>setKipindi(v)}
          style={{flex:1,padding:"9px",borderRadius:"var(--r2)",border:"none",cursor:"pointer",
            fontWeight:700,fontSize:12,fontFamily:"var(--font)",
            background:kipindi===v?"var(--teal)":"transparent",
            color:kipindi===v?"white":"var(--gray-500)"}}>
          {l}
        </button>
      ))}
    </div>
    <div className="grid2" style={{marginBottom:12}}>
      {[
        {l:"Mapato — "+kipindiLabel,v:fmt(mapato),c:"var(--teal)",ic:"📈"},
        {l:"Faida Ghafi",v:fmt(Math.max(0,parseFloat(m.faida_ghafi||0))),c:"var(--green)",ic:"💰"},
        {l:"Jumla Matumizi",v:fmt(matumizi),c:"var(--red)",ic:"💳"},
        {l:"Faida Halisi",v:fmt(Math.max(0,faida)),c:faida>=0?"var(--green)":"var(--red)",ic:"🏆"},
      ].map((k,i)=><Card key={i} style={{padding:"14px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <div style={{fontSize:10,fontWeight:700,color:"var(--gray-400)",textTransform:"uppercase",letterSpacing:.8}}>{k.l}</div>
          <span style={{fontSize:18}}>{k.ic}</span>
        </div>
        <div style={{fontSize:18,fontWeight:900,color:k.c}}>{k.v}</div>
      </Card>)}
    </div>

    <Card style={{marginBottom:12}}>
      <div style={{fontSize:13,fontWeight:800,marginBottom:12}}>Muhtasari wa Bidhaa</div>
      {[
        {l:"Bidhaa Zote",v:prods.length,c:"var(--teal)"},
        {l:"Zimeisha",v:prods.filter(p=>(p.stock||p.idadi||0)===0).length,c:"var(--red)"},
        {l:"Zinakwisha (≤5)",v:prods.filter(p=>{const s=p.stock||p.idadi||0;const m=p.min_stock||5;return s>0&&s<=m;}).length,c:"var(--amber)"},
      ].map((r,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",
        padding:"8px 0",borderBottom:"1px solid var(--gray-100)"}}>
        <span style={{fontSize:13,fontWeight:500}}>{r.l}</span>
        <span style={{fontSize:14,fontWeight:800,color:r.c}}>{r.v}</span>
      </div>)}
    </Card>

    {njia.length>0&&<Card style={{marginBottom:12}}>
      <div style={{fontSize:13,fontWeight:800,marginBottom:12}}>Mauzo kwa Njia ya Malipo</div>
      {njia.map((n,i)=>{
        const colors={cash:"var(--green)",mpesa:"var(--teal)",airtel:"var(--red)",tigo:"var(--blue)",mkopo:"var(--amber)"};
        const key=n.njia.toLowerCase().replace("-","").replace("pesa","pesa");
        const col=colors[key]||"var(--gray-400)";
        const total=njia.reduce((s,x)=>s+x.jumla,0);
        const pct=total>0?Math.round((n.jumla/total)*100):0;
        return <div key={i} style={{marginBottom:12}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <span style={{fontSize:12,fontWeight:700,textTransform:"capitalize"}}>{n.njia}</span>
              <Badge color={key==="cash"?"green":key==="mpesa"?"teal":key==="airtel"?"red":key==="tigo"?"blue":"amber"}>
                {n.idadi} malipo
              </Badge>
            </div>
            <div style={{fontSize:13,fontWeight:800,color:col}}>{fmt(n.jumla)}</div>
          </div>
          <div style={{height:6,background:"var(--gray-100)",borderRadius:3,overflow:"hidden"}}>
            <div style={{width:pct+"%",height:"100%",background:col,borderRadius:3,transition:"width .5s"}}/>
          </div>
          <div style={{fontSize:10,color:"var(--gray-400)",marginTop:2,textAlign:"right"}}>{pct}%</div>
        </div>;
      })}
      <div style={{borderTop:"1px solid var(--gray-100)",paddingTop:10,display:"flex",justifyContent:"space-between"}}>
        <span style={{fontSize:12,fontWeight:700,color:"var(--gray-600)"}}>Jumla Yote</span>
        <span style={{fontSize:14,fontWeight:900,color:"var(--teal)"}}>{fmt(njia.reduce((s,n)=>s+n.jumla,0))}</span>
      </div>
    </Card>}

    <Card>
      <div style={{fontSize:13,fontWeight:800,marginBottom:12}}>Hali ya Uchapishaji</div>
      {[
        {ph:"Phase 1 DONE",t:"Browser Print",d:"Chapisha risiti — inafanya kazi sasa.",c:"var(--green)"},
        {ph:"Phase 2",t:"QZ Tray 80mm",d:"ESC/POS — Epson, Bixolon.",c:"var(--teal)"},
        {ph:"Phase 3",t:"Bluetooth 58mm",d:"Web Bluetooth — Chrome Android.",c:"var(--amber)"},
      ].map(p=><div key={p.ph} style={{padding:"10px 12px",background:"var(--gray-50)",
        border:"2px solid "+p.c+"33",borderRadius:"var(--r2)",marginBottom:8}}>
        <div style={{fontSize:10,color:p.c,fontWeight:800,marginBottom:3,textTransform:"uppercase"}}>{p.ph}</div>
        <div style={{fontSize:12,fontWeight:700,marginBottom:3}}>{p.t}</div>
        <div style={{fontSize:11,color:"var(--gray-500)"}}>{p.d}</div>
      </div>)}
    </Card>
  </div>;
}


/* ─── SIDE DRAWER ────────────────────────────────────────────────────────── */
function SideDrawer({open,onClose,tab,switchTab,shop,user,zeroLock,setZeroLock,payModes,setPayModes,onLogout,onSettings}){
  const isOwner=!user?.is_staff||user?.role==="admin";
  const ALL_PAY=["Cash","M-Pesa","Airtel","Tigo","Mkopo"];
  return <>
    {open&&<div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",zIndex:200,backdropFilter:"blur(2px)"}}/>}
    <div style={{position:"fixed",top:0,left:0,bottom:0,width:280,background:"white",zIndex:201,
      boxShadow:"4px 0 24px rgba(0,0,0,.12)",
      transform:open?"translateX(0)":"translateX(-100%)",
      transition:"transform .28s cubic-bezier(.4,0,.2,1)",
      display:"flex",flexDirection:"column",overflowY:"auto"}}>
      <div style={{background:"linear-gradient(135deg,var(--teal),var(--teal-d))",padding:"24px 20px 20px",color:"white"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
          <div style={{width:44,height:44,background:"rgba(255,255,255,.2)",borderRadius:12,
            display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,overflow:"hidden",padding:0}}><img src="/icon-192.png" alt="HS" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:8}}/></div>
          <div>
            <div style={{fontSize:16,fontWeight:900}}>Hesabu Smart</div>
            <div style={{fontSize:11,opacity:.75,marginTop:2}}>ERP v4.0</div>
          </div>
        </div>
        <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"10px 14px"}}>
          <div style={{fontSize:13,fontWeight:700}}>{shop?.owner_name||shop?.name||"Mtumiaji"}</div>
          <div style={{fontSize:10,opacity:.75,marginTop:2}}>{user?.is_staff?user?.role==="admin"?"Admin":"Muuzaji":"Mmiliki"}</div>
        </div>
      </div>
      <div style={{flex:1,padding:"12px 0"}}>
        {isOwner&&<>
          <div style={{padding:"8px 20px 4px",fontSize:10,fontWeight:800,color:"var(--gray-400)",textTransform:"uppercase",letterSpacing:1}}>Usimamizi</div>
          {[{id:"ripoti",icon:"📊",label:"Ripoti"},{id:"watumiaji",icon:"👤",label:"Watumiaji"}].map(t=>(
            <button key={t.id} onClick={()=>{switchTab(t.id);onClose();}}
              style={{width:"100%",padding:"13px 20px",background:tab===t.id?"var(--teal-l)":"none",
                border:"none",cursor:"pointer",fontFamily:"var(--font)",display:"flex",alignItems:"center",
                gap:14,textAlign:"left",borderLeft:"3px solid "+(tab===t.id?"var(--teal)":"transparent"),
                transition:"all .15s"}}>
              <span style={{fontSize:20}}>{t.icon}</span>
              <span style={{fontSize:13,fontWeight:tab===t.id?800:500,
                color:tab===t.id?"var(--teal)":"var(--gray-700)"}}>{t.label}</span>
            </button>
          ))}
          <div style={{height:1,background:"var(--gray-100)",margin:"8px 0"}}/>
          <div style={{padding:"8px 20px 4px",fontSize:10,fontWeight:800,color:"var(--gray-400)",textTransform:"uppercase",letterSpacing:1}}>Mipangilio</div>
          <div style={{padding:"12px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <div style={{fontSize:13,fontWeight:600,color:"var(--gray-700)"}}>Zero-Stock Lock</div>
              <div style={{fontSize:11,color:"var(--gray-400)",marginTop:2}}>Zuia mauzo bila stoki</div>
            </div>
            <div onClick={()=>setZeroLock(b=>!b)} style={{width:40,height:22,borderRadius:11,cursor:"pointer",
              background:zeroLock?"var(--teal)":"var(--gray-200)",position:"relative",transition:"background .25s",flexShrink:0}}>
              <div style={{position:"absolute",top:3,left:zeroLock?19:3,width:16,height:16,borderRadius:"50%",
                background:"white",transition:"left .25s",boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}/>
            </div>
          </div>
          <div style={{padding:"4px 20px 12px"}}>
            <div style={{fontSize:13,fontWeight:600,color:"var(--gray-700)",marginBottom:8}}>Njia za Malipo</div>
            {ALL_PAY.map(p=>(
              <div key={p} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
                padding:"7px 0",borderBottom:"1px solid var(--gray-100)"}}>
                <span style={{fontSize:12,color:"var(--gray-700)"}}>{p}</span>
                <div onClick={()=>setPayModes(pm=>pm.includes(p)?pm.filter(x=>x!==p):[...pm,p])}
                  style={{width:34,height:19,borderRadius:10,cursor:"pointer",flexShrink:0,
                    background:payModes.includes(p)?"var(--teal)":"var(--gray-200)",
                    position:"relative",transition:"background .25s"}}>
                  <div style={{position:"absolute",top:2.5,left:payModes.includes(p)?15:2.5,width:14,height:14,
                    borderRadius:"50%",background:"white",transition:"left .25s",
                    boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}/>
                </div>
              </div>
            ))}
          </div>
        </>}
      </div>
      <div style={{padding:"16px 20px",borderTop:"1px solid var(--gray-100)"}}>
        <button onClick={()=>{onClose();onSettings();}}
          style={{width:"100%",padding:"12px",background:"var(--gray-100)",
            border:"none",borderRadius:"var(--r2)",cursor:"pointer",fontFamily:"var(--font)",
            fontSize:13,fontWeight:700,color:"var(--gray-700)",display:"flex",alignItems:"center",
            justifyContent:"center",gap:8,marginBottom:8}}>
          ⚙️ Mipangilio ya Akaunti
        </button>
        <button onClick={onLogout} style={{width:"100%",padding:"12px",background:"var(--red-l)",
          border:"none",borderRadius:"var(--r2)",cursor:"pointer",fontFamily:"var(--font)",
          fontSize:13,fontWeight:700,color:"var(--red)",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          🚪 Toka
        </button>
      </div>
    </div>
  </>;
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/* ─── MAIN APP ───────────────────────────────────────────────────────────── */
/* ═══════════════════════════════════════════════════════════════════════════ */

function ShopSettingsModal({shop, onClose, onUpdate, onToast}){
  const [tab, setTab] = useState("duka");
  const [form, setForm] = useState({
    name: shop?.name||"", owner_name: shop?.owner_name||"",
    phone: "", location: shop?.location||""
  });
  // Load fresh profile from server on mount
  useEffect(()=>{
    apiFetch("/auth/wasifu").then(data=>{
      setForm({name:data.name||"",owner_name:data.owner_name||"",phone:data.phone||"",location:data.location||""});
    }).catch(()=>{});
  },[]);
  const [pwdForm, setPwdForm] = useState({current:"", newpwd:"", confirm:""});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  async function saveProfile(){
    if(!form.name){onToast("Jaza jina la duka","error");return;}
    setLoading(true);
    try{
      const res = await apiFetch("/auth/wasifu-hariri", {
        method:"PATCH", body: JSON.stringify(form)
      });
      const updated = {...shop, ...res};
      localStorage.setItem("hs_shop", JSON.stringify(updated));
      onUpdate(updated);
      onToast("Imehifadhiwa","success");
      onClose();
    }catch(e){onToast(e.message,"error");}
    setLoading(false);
  }

  async function changePassword(){
    if(!pwdForm.current||!pwdForm.newpwd){onToast("Jaza sehemu zote","error");return;}
    if(pwdForm.newpwd.length<6){onToast("Nywila mpya iwe na herufi 6+","error");return;}
    if(pwdForm.newpwd!==pwdForm.confirm){onToast("Nywila mpya hazifanani","error");return;}
    setLoading(true);
    try{
      await apiFetch("/auth/badilisha-nywila", {
        method:"POST", body: JSON.stringify({current_password:pwdForm.current, new_password:pwdForm.newpwd})
      });
      onToast("Nywila imebadilishwa","success");
      setPwdForm({current:"",newpwd:"",confirm:""});
      onClose();
    }catch(e){onToast(e.message,"error");}
    setLoading(false);
  }

  return(
    <Modal title="Mipangilio ya Akaunti" onClose={onClose}>
      <div style={{display:"flex",gap:4,marginBottom:16,background:"var(--gray-100)",borderRadius:"var(--r2)",padding:3}}>
        {[["duka","🏪 Duka"],["nywila","🔒 Nywila"]].map(([v,l])=>(
          <button key={v} onClick={()=>setTab(v)}
            style={{flex:1,padding:"9px",borderRadius:"var(--r2)",border:"none",cursor:"pointer",
              fontWeight:700,fontSize:12,fontFamily:"var(--font)",
              background:tab===v?"var(--teal)":"transparent",
              color:tab===v?"white":"var(--gray-500)"}}>
            {l}
          </button>
        ))}
      </div>
      {success&&<div style={{background:"var(--green-l)",border:"1px solid #a7f3d0",borderRadius:"var(--r2)",
        padding:"10px 14px",marginBottom:12,fontSize:13,color:"var(--green)",fontWeight:600}}>{success}</div>}
      {tab==="duka"&&<>
        <Inp label="Jina la Duka *" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Duka la Mama Amina"/>
        <Inp label="Jina la Mmiliki" value={form.owner_name} onChange={e=>setForm(f=>({...f,owner_name:e.target.value}))} placeholder="Amina Hassan"/>
        <Inp label="Simu" value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} placeholder="0712345678"/>
        <Inp label="Mahali" value={form.location} onChange={e=>setForm(f=>({...f,location:e.target.value}))} placeholder="Arusha"/>
        <Btn v="primary" sz="lg" full onClick={saveProfile} disabled={loading}>
          {loading?"Inahifadhi...":"Hifadhi Mabadiliko"}
        </Btn>
      </>}
      {tab==="nywila"&&<>
        <Inp label="Nywila ya Sasa *" type="password" value={pwdForm.current} onChange={e=>setPwdForm(f=>({...f,current:e.target.value}))} placeholder="••••••••"/>
        <Inp label="Nywila Mpya *" type="password" value={pwdForm.newpwd} onChange={e=>setPwdForm(f=>({...f,newpwd:e.target.value}))} placeholder="••••••••"/>
        <Inp label="Thibitisha Nywila Mpya *" type="password" value={pwdForm.confirm} onChange={e=>setPwdForm(f=>({...f,confirm:e.target.value}))} placeholder="••••••••"/>
        <Btn v="primary" sz="lg" full onClick={changePassword} disabled={loading}>
          {loading?"Inabadilisha...":"Badilisha Nywila"}
        </Btn>
      </>}
    </Modal>
  );
}

export default function HesabuSmartERP(){
  if(window.location.pathname.startsWith("/admin")){return <AdminPanel />;}
  // ── Auth state ─────────────────────────────────────────────────────────────
  const [shop,setShop]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("hs_shop"));}catch{return null;}
  });
  const isLoggedIn=!!(shop&&localStorage.getItem("hs_token"));

  // ── App state ──────────────────────────────────────────────────────────────
  const [tab,setTab]=useState(()=>localStorage.getItem("hs_last_tab")||"nyumbani");
  const [prods,setProds]=useState([]);
  const [zeroLock,setZeroLock]=useState(true);
  const [payModes,setPayModes]=useState(["Cash","M-Pesa","Airtel","Tigo","Mkopo"]);
  const [drawerOpen,setDrawerOpen]=useState(false);
  const [showSettings,setShowSettings]=useState(false);
  const user=JSON.parse(localStorage.getItem("hs_user")||"null");
  const isOwner=!user?.is_staff||user?.role==="admin";
  const [toast,setToast]=useState(null);
  const [showScanner,setShowScanner]=useState(false);
  const [printData,setPrintData]=useState(null);

  const showToast=useCallback((msg,type="success")=>setToast({message:msg,type}),[]);

  // ── Load products after login ──────────────────────────────────────────────
  useEffect(()=>{
    if(isLoggedIn){
      api.products.list().then(list=>{
        const mapped = list.map(p=>({...p,
          name:p.name||p.jina||"",
          price:p.price||p.bei_uuzaji||0,
          stock:p.stock??p.idadi??0,
        }));
        setProds(mapped);
      }).catch(()=>{ setProds([]); });
    }
  },[isLoggedIn]);

  // ── Remember last tab ──────────────────────────────────────────────────────
  function switchTab(t){
    setTab(t);
    localStorage.setItem("hs_last_tab",t);
  }

  function handleScan(code){
    const p=prods.find(x=>x.barcode===code||x.sku===code);
    showToast(p?"Imepatikana: "+(p.name||p.jina):"Barcode "+code+" haikupatikana",p?"success":"error");
    setShowScanner(false);
  }

  function handleLogout(){
    localStorage.removeItem("hs_token");
    localStorage.removeItem("hs_shop");
    localStorage.removeItem("hs_last_tab");
    setShop(null);
  }

  // ── Not logged in → show auth screen ──────────────────────────────────────
  if(!isLoggedIn){
    return <AuthScreen onLogin={s=>{setShop(s);setTab("nyumbani");}}/>;
  }


  const TABS=[
    {id:"nyumbani",icon:"🏠",label:"Nyumbani"},
    {id:"mauzo",icon:"🛒",label:"Mauzo"},
    {id:"bidhaa",icon:"📦",label:"Bidhaa"},
    {id:"wateja",icon:"👥",label:"Wateja"},
    {id:"matumizi",icon:"💳",label:"Matumizi"},
    {id:"nukuu",icon:"💬",label:"Nukuu"},
  ];

  return(
    <div style={{minHeight:"100vh",background:"var(--gray-50)",fontFamily:"var(--font)"}}>
      <G/>

      {/* SIDE DRAWER */}
      {showSettings&&<ShopSettingsModal shop={shop} onClose={()=>setShowSettings(false)}
        onUpdate={sh=>{setShop(sh);localStorage.setItem("hs_shop",JSON.stringify(sh));}}
        onToast={showToast}/>}
      <SideDrawer open={drawerOpen} onClose={()=>setDrawerOpen(false)}
        tab={tab} switchTab={switchTab} shop={shop} user={user}
        zeroLock={zeroLock} setZeroLock={setZeroLock}
        payModes={payModes} setPayModes={setPayModes}
        onLogout={handleLogout}
        onSettings={()=>setShowSettings(true)}/>

      {/* TOP BAR */}
      <div style={{background:"white",borderBottom:"1px solid var(--gray-200)",
        padding:"0 14px",height:56,display:"flex",alignItems:"center",
        justifyContent:"space-between",position:"sticky",top:0,zIndex:100,boxShadow:"var(--sh)"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <button onClick={()=>setDrawerOpen(true)}
            style={{background:"none",border:"none",cursor:"pointer",padding:"6px",
              display:"flex",flexDirection:"column",gap:4,borderRadius:"var(--r3)"}}>
            {[0,1,2].map(i=><div key={i} style={{width:20,height:2,background:"var(--teal)",borderRadius:2}}/>)}
          </button>
          <div>
            <div style={{fontSize:14,fontWeight:900,color:"var(--teal)",letterSpacing:"-.3px",lineHeight:1.2}}>
              Hesabu Smart
            </div>
            <div style={{fontSize:9,color:"var(--gray-400)",fontWeight:600}}>
              {user?.is_staff?user?.jina||user?.name:shop?.owner_name||shop?.name||""}
            </div>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <button onClick={()=>setShowScanner(true)}
            style={{background:"var(--teal-l)",border:"2px solid var(--teal)",color:"var(--teal)",
              padding:"6px 11px",borderRadius:"var(--r2)",cursor:"pointer",fontSize:18,
              fontWeight:800,fontFamily:"var(--font)"}}>📷</button>
        </div>
      </div>

      {/* CONTENT */}
      <div style={{maxWidth:900,margin:"0 auto",padding:"14px 12px 84px"}}>
        {tab==="nyumbani"&&<TabNyumbani shop={shop}/>}
        {tab==="mauzo"&&<TabMauzo prods={prods} setProds={setProds} zeroLock={zeroLock}
          payModes={payModes}
          onToast={showToast} onScan={()=>setShowScanner(true)} onPrint={d=>setPrintData(d)}/>}
        {tab==="bidhaa"&&<TabBidhaa prods={prods} setProds={setProds} zeroLock={zeroLock}
          setZeroLock={setZeroLock} onToast={showToast} onScan={()=>setShowScanner(true)} isOwner={isOwner}/>}
        {tab==="wateja"&&<TabWateja onToast={showToast}/>}
        {tab==="matumizi"&&<TabMatumizi onToast={showToast}/>}
        {tab==="nukuu"&&<TabNukuu prods={prods} zeroLock={zeroLock}
          onToast={showToast} onScan={()=>setShowScanner(true)} onPrint={d=>setPrintData(d)}/>}
        {tab==="watumiaji"&&<TabTimu onToast={showToast} shop={shop}/>}
        {tab==="ripoti"&&<TabRipoti prods={prods} onToast={showToast}/>}
      </div>

      {/* BOTTOM NAV */}
      <div style={{position:"fixed",bottom:0,left:0,right:0,background:"white",
        borderTop:"1px solid var(--gray-200)",display:"flex",zIndex:100,
        boxShadow:"0 -2px 10px rgba(0,0,0,.06)"}}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>switchTab(t.id)}
            style={{flex:1,padding:"7px 2px 9px",background:"none",border:"none",
              cursor:"pointer",fontFamily:"var(--font)",display:"flex",flexDirection:"column",
              alignItems:"center",gap:2,transition:"all .15s",
              borderTop:"2.5px solid "+(tab===t.id?"var(--teal)":"transparent")}}>
            <span style={{fontSize:20}}>{t.icon}</span>
            <span style={{fontSize:8,fontWeight:700,letterSpacing:.3,textTransform:"uppercase",
              color:tab===t.id?"var(--teal)":"var(--gray-400)"}}>{t.label}</span>
          </button>
        ))}
      </div>
      {showScanner&&<ScanModal onScan={handleScan} onClose={()=>setShowScanner(false)}/>}
      {printData&&<PrintModal {...printData} onClose={()=>setPrintData(null)}/>}
      {toast&&<Toast {...toast} onDone={()=>setToast(null)}/>}
    </div>
  );
}
